const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    "cartUpdate": "cart-update",
    "quantityUpdate": "quantity-update",
    "optionValueSelectionChange": "option-value-selection-change",
    "variantChange": "variant-change",
    "cartError": "cart-error"
  };
let subscribers = {};
function subscribe(_0x28c619, _0x1930c0) {
  return subscribers[_0x28c619] === undefined && (subscribers[_0x28c619] = []), subscribers[_0x28c619] = [...subscribers[_0x28c619], _0x1930c0], function _0xc86a0() {
    subscribers[_0x28c619] = subscribers[_0x28c619].filter(_0x5bd1c8 => {
      return _0x5bd1c8 !== _0x1930c0;
    });
  };
}
function publish(_0x20ed64, _0x471bac) {
  subscribers[_0x20ed64] && subscribers[_0x20ed64].forEach(_0x3e23ef => {
    _0x3e23ef(_0x471bac);
  });
}
const GIFTS_LOCAL_STORAGE_KEY = "shrine_gift_goals";
let shouldCheckShrineGifts = false,
  giftsToMonitor = [];
function initShrineGiftsCheck(_0x4267dc = false) {
  let _0x4cd163 = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (_0x4267dc) _0x4cd163 = document.querySelector("cart-items");
  if (!_0x4cd163 || _0x4cd163.dataset.giftsStorage !== "true") return;
  const _0x55f358 = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (!_0x55f358) return;
  const _0x54237a = JSON.parse(_0x55f358);
  if (!_0x54237a || typeof _0x54237a !== "object") return;
  Object.values(_0x54237a).forEach(_0x2d16bc => {
    const _0x56dc50 = _0x4cd163.querySelector(".cart-item--product-" + _0x2d16bc.gift_handle);
    if (!_0x56dc50) return;
    const _0x5f4fc9 = document.querySelector(".gift--product-" + _0x2d16bc.gift_handle);
    if (_0x5f4fc9) return;
    shouldCheckShrineGifts = true, giftsToMonitor.push(_0x2d16bc);
  }), updateGiftStyles(), checkShrineGifts(_0x4267dc);
}
function updateGiftStyles() {
  let _0x2d43e0 = document.getElementById("shrine-gifts-style");
  if (_0x2d43e0) _0x2d43e0.remove();
  if (!giftsToMonitor.length) return;
  const _0x2474d9 = document.createElement("style");
  _0x2474d9.id = "shrine-gifts-style";
  const _0x3a15a8 = giftsToMonitor.map(_0x1f02be => ".cart-item--product-" + _0x1f02be.gift_handle + " .quantity { display: none !important; }").join("\n");
  _0x2474d9.textContent = _0x3a15a8, document.head.appendChild(_0x2474d9);
}
function checkShrineGifts(_0x1370c2 = false) {
  let _0x47d3f9 = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (_0x1370c2) _0x47d3f9 = document.querySelector("cart-items");
  if (!shouldCheckShrineGifts || !_0x47d3f9 || !_0x47d3f9.updateQuantity) return;
  for (const _0x26a56d of giftsToMonitor) {
    const _0x36d5b4 = _0x47d3f9.querySelector(".cart-item--product-" + _0x26a56d.gift_handle);
    if (!_0x36d5b4) {
      const _0x24352b = giftsToMonitor.findIndex(_0x325c39 => _0x325c39.gift_handle === _0x26a56d.gift_handle);
      if (_0x24352b > -1) giftsToMonitor.splice(_0x24352b, 1);
      removeLocalStorageGift(_0x26a56d);
      continue;
    }
    let _0x111746 = false;
    if (_0x26a56d.type === "product_quantity") {
      let _0x1c1ce0 = 0;
      _0x47d3f9.querySelectorAll(".cart-item--product-" + _0x26a56d.unlock_product_handle).forEach(_0x5d81a3 => {
        _0x1c1ce0 += parseInt(_0x5d81a3.dataset.quantity);
      });
      if (_0x1c1ce0 < parseInt(_0x26a56d.required_quantity)) _0x111746 = true;
    } else {
      if (_0x26a56d.type === "product_variant") {
        const _0x3c2cdd = _0x47d3f9.querySelectorAll(".cart-item--product-" + _0x26a56d.unlock_product_handle);
        if (!_0x3c2cdd.length) _0x111746 = true;else {
          const _0x2e00da = Array.isArray(_0x26a56d.valid_variants) ? _0x26a56d.valid_variants : [];
          let _0x13aeaa = false,
            _0x3c8b3b = false;
          _0x3c2cdd.forEach(_0x2217d0 => {
            const _0x3f136c = _0x2217d0.dataset.variantOptions;
            if (_0x3f136c) {
              _0x3c8b3b = true;
              const _0xe99fd = _0x3f136c.split("|||").map(_0x48cd69 => _0x48cd69.trim().toLowerCase());
              _0xe99fd.some(_0x20b0b3 => _0x2e00da.includes(_0x20b0b3)) && (_0x13aeaa = true);
            }
          });
          if (_0x3c8b3b && !_0x13aeaa) _0x111746 = true;
        }
      } else {
        const _0x276800 = parseInt(_0x47d3f9.dataset.subtotal);
        if (_0x276800 < parseInt(_0x26a56d.required_quantity)) _0x111746 = true;
      }
    }
    if (_0x111746) {
      const _0x35ad4d = giftsToMonitor.findIndex(_0x16ba85 => _0x16ba85.gift_handle === _0x26a56d.gift_handle);
      if (_0x35ad4d > -1) giftsToMonitor.splice(_0x35ad4d, 1);
      removeLocalStorageGift(_0x26a56d);
      const _0x528514 = _0x36d5b4.dataset.index ?? _0x36d5b4.id.replace("CartItem-", "");
      _0x47d3f9.updateQuantity(_0x528514, 0);
      return;
    }
  }
}
function validateSingleQuantityCartItems(_0x381d8f, _0x3a0779) {
  for (const [_0xf31e62, _0x45e972] of Object.entries(_0x3a0779)) {
    const _0x57018e = _0x381d8f.querySelectorAll(".cart-item--product-" + _0xf31e62);
    if (_0x57018e.length === 0) continue;
    if (_0x57018e.length > 1) {
      let _0x9a988d = null,
        _0x19ec5f = [];
      _0x57018e.forEach(_0x2e807c => {
        const _0x5440f5 = _0x2e807c.querySelector("[data-quantity-variant-id]"),
          _0x4867d7 = _0x5440f5 ? _0x5440f5.dataset.quantityVariantId : null;
        _0x4867d7 === _0x45e972 && !_0x9a988d ? _0x9a988d = _0x2e807c : _0x19ec5f.push(_0x2e807c);
      });
      !_0x9a988d && _0x19ec5f.length > 0 && (_0x9a988d = _0x19ec5f.shift());
      if (_0x19ec5f.length > 0) {
        const _0x340c82 = _0x19ec5f[0],
          _0x5c1175 = _0x340c82.dataset.index ?? _0x340c82.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
        return _0x381d8f.updateQuantity(_0x5c1175, 0), true;
      }
    }
    if (_0x57018e.length === 1) {
      const _0x2a273c = _0x57018e[0],
        _0x5457da = parseInt(_0x2a273c.dataset.quantity) || 1;
      if (_0x5457da > 1) {
        const _0x5a578f = _0x2a273c.dataset.index ?? _0x2a273c.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
        return _0x381d8f.updateQuantity(_0x5a578f, 1), true;
      }
    }
  }
  return false;
}
function validateCartGifts(_0x57b408 = false) {
  const _0x140d09 = document.querySelector("cart-drawer");
  if (!_0x140d09) return;
  let _0x1fa6d1 = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (_0x57b408) _0x1fa6d1 = document.querySelector("cart-items");
  if (!_0x1fa6d1 || !_0x1fa6d1.updateQuantity) return;
  const _0x15d27c = _0x140d09.querySelectorAll("cart-drawer-gift"),
    _0x55950c = _0x140d09.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"]");
  if (!_0x15d27c.length && !_0x55950c.length) return;
  const _0x4b2f17 = {};
  _0x15d27c.forEach(_0x17d854 => {
    _0x17d854.dataset.handle && _0x17d854.dataset.id && _0x17d854.dataset.selected === "true" && (_0x4b2f17[_0x17d854.dataset.handle] = _0x17d854.dataset.id);
  });
  const _0x243a1f = {};
  _0x55950c.forEach(_0x4e7049 => {
    _0x4e7049.dataset.handle && _0x4e7049.dataset.id && _0x4e7049.dataset.selected === "true" && (_0x243a1f[_0x4e7049.dataset.handle] = _0x4e7049.dataset.id);
  });
  if (validateSingleQuantityCartItems(_0x1fa6d1, _0x4b2f17)) return;
  if (validateSingleQuantityCartItems(_0x1fa6d1, _0x243a1f)) return;
}
function removeLocalStorageGift(_0x38dade) {
  const _0x5a818e = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (_0x5a818e) try {
    const _0x250250 = JSON.parse(_0x5a818e);
    _0x250250 && _0x250250[_0x38dade.gift_handle] && (delete _0x250250[_0x38dade.gift_handle], localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(_0x250250)));
  } catch (_0x3a667f) {
    console.warn("Error parsing gift localStorage data:", _0x3a667f);
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", _0xa47869 => {
      _0xa47869.preventDefault();
      if (this.dataset.handle) {
        const _0x4f6a84 = this.dataset.handle,
          _0x36d76a = document.querySelectorAll(".quantity-break__upsell[data-handle=\"" + _0x4f6a84 + "\"]");
        _0x36d76a.forEach(_0x1726cd => {
          _0x1726cd.dataset.selected = "false", _0x1726cd.classList.remove("quantity-break__upsell--selected");
          const _0xd95d9f = _0x1726cd.querySelector("input[type=\"checkbox\"]");
          if (_0xd95d9f) _0xd95d9f.checked = false;
        });
      }
      const _0x3dc6e5 = this.closest("cart-items") || this.closest("cart-drawer-items");
      this.clearCart ? _0x3dc6e5.clearCart() : _0x3dc6e5.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"), this.secondCartItems = document.querySelector("cart-drawer-items"), this.quantityGifts = document.querySelector(".quantity-gifts");
    const _0x163086 = debounce(_0x1898dc => {
      this.onChange(_0x1898dc);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", _0x163086.bind(this)), this.isCartPage = this.nodeName === "CART-ITEMS", this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : "cart-items", this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
    if (this.hasOtherCartItems) {
      if (this.isCartPage) initShrineGiftsCheck(true);
    } else initShrineGiftsCheck(false);
  }
  ["cartUpdateUnsubscriber"] = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, _0x4deee6 => {
      if (_0x4deee6.source === "cart-items") return;
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(_0x27a273) {
    this.updateQuantity(_0x27a273.target.dataset.index, _0x27a273.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(_0x4999ea => _0x4999ea.text()).then(_0x31de34 => {
      const _0xc367d5 = new DOMParser().parseFromString(_0x31de34, "text/html"),
        _0x4f3b8f = _0xc367d5.querySelector("cart-items");
      this.innerHTML = _0x4f3b8f.innerHTML;
    })["catch"](_0x215942 => {
      console.error(_0x215942);
    });
  }
  updateCart() {
    const _0x281f88 = JSON.stringify({
      "sections": this.getSectionsToRender().map(_0x1c0489 => _0x1c0489.section),
      "sections_url": window.location.pathname
    });
    fetch("/cart/update.js", {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "body": _0x281f88
    }).then(_0x307539 => _0x307539.json()).then(_0x2dbd4f => {
      this.classList.toggle("is-empty", _0x2dbd4f.item_count === 0), this.getSectionsToRender().forEach(_0x4448ad => {
        const _0x23bf81 = document.getElementById(_0x4448ad.id).querySelector(_0x4448ad.selector) || document.getElementById(_0x4448ad.id);
        _0x23bf81.innerHTML = this.getSectionInnerHTML(_0x2dbd4f.sections[_0x4448ad.section], _0x4448ad.selector);
      });
    })["catch"](_0x2562ee => {
      console.error(_0x2562ee);
    });
  }
  getSectionsToRender() {
    return [{
      "id": "main-cart-items",
      "section": document.getElementById("main-cart-items").dataset.id,
      "selector": ".js-contents"
    }, {
      "id": "cart-icon-bubble",
      "section": "cart-icon-bubble",
      "selector": ".shopify-section"
    }, {
      "id": "cart-live-region-text",
      "section": "cart-live-region-text",
      "selector": ".shopify-section"
    }, {
      "id": "main-cart-footer",
      "section": document.getElementById("main-cart-footer").dataset.id,
      "selector": ".js-contents"
    }];
  }
  async updateQuantity(_0x98c261, _0x16e2cd, _0x1b0114) {
    this.enableLoading(_0x98c261);
    const _0x54d27a = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (_0x54d27a) _0x54d27a.textContent = "";
    const _0x3184ed = JSON.stringify({
      "line": _0x98c261,
      "quantity": _0x16e2cd,
      "sections": this.getSectionsToRender().map(_0x37c1b9 => _0x37c1b9.section),
      "sections_url": window.location.pathname
    });
    try {
      const _0x4f1c51 = await fetch("" + routes.cart_change_url, {
          ...fetchConfig(),
          ...{
            "body": _0x3184ed
          }
        }),
        _0x45eb8b = await _0x4f1c51.text(),
        _0x5154bb = JSON.parse(_0x45eb8b),
        _0x4f6061 = document.getElementById("Quantity-" + _0x98c261) || document.getElementById("Drawer-quantity-" + _0x98c261),
        _0x90ec12 = document.querySelectorAll(".cart-item");
      if (_0x5154bb.errors) {
        _0x4f6061.value = _0x4f6061.getAttribute("value"), this.updateLiveRegions(_0x98c261, _0x5154bb.errors);
        return;
      }
      if (!_0x5154bb.sections) {
        const _0x27d091 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(_0x2e4512 => _0x2e4512.section).join(","));
        _0x5154bb.sections = await _0x27d091.json();
      }
      this.classList.toggle("is-empty", _0x5154bb.item_count === 0);
      const _0x505127 = document.querySelector("cart-drawer"),
        _0x51a559 = document.getElementById("main-cart-footer");
      if (_0x51a559) _0x51a559.classList.toggle("is-empty", _0x5154bb.item_count === 0);
      if (_0x505127) _0x505127.classList.toggle("is-empty", _0x5154bb.item_count === 0);
      this.getSectionsToRender().forEach(_0x1a0414 => {
        const _0x441a9a = document.getElementById(_0x1a0414.id);
        if (_0x441a9a) {
          const _0x1d5b8d = _0x441a9a.querySelector(_0x1a0414.selector) || _0x441a9a;
          _0x1d5b8d.innerHTML = this.getSectionInnerHTML(_0x5154bb.sections[_0x1a0414.section], _0x1a0414.selector);
          const _0x4c9165 = _0x1d5b8d.querySelector(".cart-drawer__body");
          if (_0x4c9165 && this.cartDrawer) _0x4c9165.scrollTop = this.cartDrawer.cartBodyScroll;
        }
      });
      const _0x296163 = _0x5154bb.items[_0x98c261 - 1] ? _0x5154bb.items[_0x98c261 - 1].quantity : undefined;
      let _0x510d43 = "";
      _0x90ec12.length === _0x5154bb.items.length && _0x296163 !== parseInt(_0x4f6061.value) && (typeof _0x296163 === "undefined" ? _0x510d43 = window.cartStrings.error : _0x510d43 = window.cartStrings.quantityError.replace("[quantity]", _0x296163));
      this.updateLiveRegions(_0x98c261, _0x510d43);
      const _0x5a2d40 = document.getElementById("CartItem-" + _0x98c261) || document.getElementById("CartDrawer-Item-" + _0x98c261);
      if (_0x5a2d40 && _0x5a2d40.querySelector("[name=\"" + _0x1b0114 + "\"]")) _0x505127 ? trapFocus(_0x505127, _0x5a2d40.querySelector("[name=\"" + _0x1b0114 + "\"]")) : _0x5a2d40.querySelector("[name=\"" + _0x1b0114 + "\"]").focus();else {
        if (_0x5154bb.item_count === 0 && _0x505127) trapFocus(_0x505127.querySelector(".drawer__inner-empty"), _0x505127.querySelector("a"));else document.querySelector(".cart-item") && _0x505127 && trapFocus(_0x505127, document.querySelector(".cart-item__name"));
      }
      if (_0x505127) {
        _0x505127.checkForClear();
        const _0x627b36 = _0x505127.querySelector("countdown-timer");
        if (_0x627b36) _0x627b36.playTimer();
        let _0x28d122 = false;
        if (_0x505127.querySelector("cart-drawer-gift")) {
          _0x505127.checkForClear();
          let _0x187465 = [],
            _0x54dd6a = [];
          _0x505127.querySelectorAll("cart-drawer-gift").forEach(_0x4de20e => {
            _0x4de20e.getUpdateRequired() && (_0x505127.querySelector(".cart-item--product-" + _0x4de20e.dataset.handle) ? _0x4de20e.dataset.selected === "false" && _0x54dd6a.push(_0x4de20e) : _0x4de20e.dataset.selected === "true" && _0x187465.push(_0x4de20e));
          });
          if (_0x54dd6a.length > 0) _0x28d122 = true, _0x54dd6a[0].removeFromCart();else _0x187465.length > 0 && (_0x28d122 = true, _0x187465[0].addToCart());
        }
        this.quantityGifts && !_0x28d122 && this.quantityGifts.initUnlock();
        const _0x2f83ce = document.querySelectorAll("quantity-break-upsells");
        _0x2f83ce.forEach(_0x431aa2 => {
          if (!_0x28d122) _0x431aa2.initUnlock();
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        "source": "cart-items",
        "cartData": _0x5154bb
      });
    } catch (_0x4f79ef) {
      console.log(_0x4f79ef), this.querySelectorAll(".loading-overlay").forEach(_0x37c9aa => _0x37c9aa.classList.add("hidden"));
      const _0x290669 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x290669.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(_0x98c261);
      if (this.secondCartItems && this.secondCartItems.updateCart) this.secondCartItems.updateCart();
      const _0x3e6b88 = new CustomEvent("cartQuantityUpdated", {
        "detail": {
          "handle": "handle"
        }
      });
      document.dispatchEvent(_0x3e6b88);
      if (shouldCheckShrineGifts) checkShrineGifts(this.isCartPage);
      validateCartGifts(this.isCartPage);
    }
  }
  updateLiveRegions(_0x34688f, _0x5ec9a5) {
    const _0xb1e078 = document.getElementById("Line-item-error-" + _0x34688f) || document.getElementById("CartDrawer-LineItemError-" + _0x34688f);
    if (_0xb1e078) _0xb1e078.querySelector(".cart-item__error-text").innerHTML = _0x5ec9a5;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const _0x57e29f = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    _0x57e29f.setAttribute("aria-hidden", false), setTimeout(() => {
      _0x57e29f.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(_0x5d9001, _0x118a88) {
    return new DOMParser().parseFromString(_0x5d9001, "text/html").querySelector(_0x118a88).innerHTML;
  }
  enableLoading(_0x3065ff) {
    const _0x42bb77 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x42bb77.classList.add("cart__items--disabled");
    const _0x33f494 = this.querySelectorAll("#CartItem-" + _0x3065ff + " .loading-overlay"),
      _0x44f841 = this.querySelectorAll("#CartDrawer-Item-" + _0x3065ff + " .loading-overlay");
    [..._0x33f494, ..._0x44f841].forEach(_0x364a07 => _0x364a07.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(_0xda617a) {
    const _0x4d7cf5 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x4d7cf5.classList.remove("cart__items--disabled");
    const _0x5e0305 = this.querySelectorAll("#CartItem-" + _0xda617a + " .loading-overlay"),
      _0x4489ed = this.querySelectorAll("#CartDrawer-Item-" + _0xda617a + " .loading-overlay");
    _0x5e0305.forEach(_0x30b54d => _0x30b54d.classList.add("hidden")), _0x4489ed.forEach(_0x34ff7e => _0x34ff7e.classList.add("hidden"));
  }
  clearCart() {
    const _0xc44243 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (_0xc44243) _0xc44243.textContent = "";
    const _0x387226 = JSON.stringify({
      "sections": this.getSectionsToRender().map(_0x6f0d54 => _0x6f0d54.section),
      "sections_url": window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        "body": _0x387226
      }
    }).then(_0x4c7630 => {
      return _0x4c7630.text();
    }).then(async _0x4e6819 => {
      const _0x521eb6 = JSON.parse(_0x4e6819);
      if (!_0x521eb6.sections) try {
        const _0x50a8b5 = this.getSectionsToRender().map(_0x270a70 => _0x270a70.id).join(","),
          _0x325eff = await fetch(routes.cart_url + "?sections=" + _0x50a8b5),
          _0x519eaf = await _0x325eff.text();
        try {
          const _0x26dcd8 = JSON.parse(_0x519eaf);
          _0x521eb6.sections = _0x26dcd8;
        } catch (_0x3efebb) {
          console.error("Clear cart fallback JSON parse failed", _0x3efebb), window.location.reload();
          return;
        }
      } catch (_0x49830c) {
        console.error("Clear cart fallback failed", _0x49830c);
        throw _0x49830c;
      }
      this.classList.add("is-empty");
      const _0x39b99d = document.querySelector("cart-drawer"),
        _0x3ca35e = document.getElementById("main-cart-footer");
      if (_0x3ca35e) _0x3ca35e.classList.add("is-empty");
      if (_0x39b99d) _0x39b99d.classList.add("is-empty");
      this.getSectionsToRender().forEach(_0x1ffbe1 => {
        const _0x5775a9 = document.getElementById(_0x1ffbe1.id).querySelector(_0x1ffbe1.selector) || document.getElementById(_0x1ffbe1.id);
        _0x5775a9.innerHTML = this.getSectionInnerHTML(_0x521eb6.sections[_0x1ffbe1.section], _0x1ffbe1.selector);
      });
      _0x39b99d && trapFocus(_0x39b99d.querySelector(".drawer__inner-empty"), _0x39b99d.querySelector("a"));
      publish(PUB_SUB_EVENTS.cartUpdate, {
        "source": "cart-items"
      });
      if (shouldCheckShrineGifts) checkShrineGifts(this.isCartPage);
    })["catch"](() => {
      this.querySelectorAll(".loading-overlay").forEach(_0x53244c => _0x53244c.classList.add("hidden"));
      const _0x4e83e9 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x4e83e9.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
!customElements.get("cart-note") && customElements.define("cart-note", class CartNote extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", debounce(_0x3300d7 => {
      const _0x34791b = JSON.stringify({
        "note": _0x3300d7.target.value
      });
      fetch("" + routes.cart_update_url, {
        ...fetchConfig(),
        ...{
          "body": _0x34791b
        }
      });
    }, ON_CHANGE_DEBOUNCE_TIMER));
  }
});
function handleDiscountForm(_0x17e76c) {
  _0x17e76c.preventDefault();
  const _0x551c1c = _0x17e76c.target.querySelector("[name=cart-discount-field]"),
    _0x2c3e37 = _0x17e76c.target.querySelector(".cart-discount-form__error"),
    _0x102171 = _0x551c1c.value;
  if (_0x102171 === undefined || _0x102171.length === 0) {
    _0x2c3e37.style.display = "block";
    return;
  }
  _0x2c3e37.style.display = "none";
  const _0x7dbb96 = "/checkout?discount=",
    _0x333119 = _0x7dbb96 + _0x102171;
  window.location.href = _0x333119;
}
function handleDiscountFormChange(_0x16e832) {
  const _0x2c96ce = document.querySelectorAll(".cart-discount-form__error");
  _0x2c96ce.forEach(_0x373a2d => {
    _0x373a2d.style.display = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input[type=\"search\"]"), this.resetButton = this.querySelector("button[type=\"reset\"]");
    this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", debounce(_0x505ae4 => {
      this.onChange(_0x505ae4);
    }, 300).bind(this)));
  }
  toggleResetButton() {
    const _0x4d6928 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && _0x4d6928) this.resetButton.classList.remove("hidden");else this.input.value.length === 0 && !_0x4d6928 && this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(_0x34dfa2) {
    _0x34dfa2.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(), this.cachedResults = {}, this.predictiveSearchResults = this.querySelector("[data-predictive-search]"), this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search"), this.isOpen = false, this.abortController = new AbortController(), this.searchTerm = "", this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.input.addEventListener("focus", this.onFocus.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const _0x23cc70 = this.getQuery();
    (!this.searchTerm || !_0x23cc70.startsWith(this.searchTerm)) && this.querySelector("#predictive-search-results-groups-wrapper")?.["remove"]();
    this.updateSearchForTerm(this.searchTerm, _0x23cc70), this.searchTerm = _0x23cc70;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(_0x40438b) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) _0x40438b.preventDefault();
  }
  onFormReset(_0x22a12f) {
    super.onFormReset(_0x22a12f), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController(), this.closeResults(true));
  }
  onFocus() {
    const _0x419ab8 = this.getQuery();
    if (!_0x419ab8.length) return;
    if (this.searchTerm !== _0x419ab8) this.onChange();else this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(this.searchTerm);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(_0x37595e) {
    if (!this.getQuery().length) this.close(true);
    _0x37595e.preventDefault();
    switch (_0x37595e.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(_0x44882b) {
    (_0x44882b.code === "ArrowUp" || _0x44882b.code === "ArrowDown") && _0x44882b.preventDefault();
  }
  updateSearchForTerm(_0x2f2352, _0x1f8856) {
    const _0x10d873 = this.querySelector("[data-predictive-search-search-for-text]"),
      _0x81408a = _0x10d873?.["innerText"];
    if (_0x81408a) {
      if (_0x81408a.match(new RegExp(_0x2f2352, "g")).length > 1) return;
      const _0x49a43a = _0x81408a.replace(_0x2f2352, _0x1f8856);
      _0x10d873.innerText = _0x49a43a;
    }
  }
  switchOption(_0xafdcf1) {
    if (!this.getAttribute("open")) return;
    const _0x129937 = _0xafdcf1 === "up",
      _0x59bf38 = this.querySelector("[aria-selected=\"true\"]"),
      _0x31f91b = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(_0x3ef217 => _0x3ef217.offsetParent !== null);
    let _0x29e71d = 0;
    if (_0x129937 && !_0x59bf38) return;
    let _0x26fd43 = -1,
      _0x480d76 = 0;
    while (_0x26fd43 === -1 && _0x480d76 <= _0x31f91b.length) {
      _0x31f91b[_0x480d76] === _0x59bf38 && (_0x26fd43 = _0x480d76), _0x480d76++;
    }
    this.statusElement.textContent = "";
    if (!_0x129937 && _0x59bf38) _0x29e71d = _0x26fd43 === _0x31f91b.length - 1 ? 0 : _0x26fd43 + 1;else _0x129937 && (_0x29e71d = _0x26fd43 === 0 ? _0x31f91b.length - 1 : _0x26fd43 - 1);
    if (_0x29e71d === _0x26fd43) return;
    const _0x123cf5 = _0x31f91b[_0x29e71d];
    _0x123cf5.setAttribute("aria-selected", true);
    if (_0x59bf38) _0x59bf38.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", _0x123cf5.id);
  }
  selectOption() {
    const _0x1595a2 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (_0x1595a2) _0x1595a2.click();
  }
  getSearchResults(_0x27ebdd) {
    const _0x2f2d99 = _0x27ebdd.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[_0x2f2d99]) {
      this.renderSearchResults(this.cachedResults[_0x2f2d99]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0x27ebdd) + "&section_id=predictive-search", {
      "signal": this.abortController.signal
    }).then(_0x28e9de => {
      if (!_0x28e9de.ok) {
        var _0x5694b1 = new Error(_0x28e9de.status);
        this.close();
        throw _0x5694b1;
      }
      return _0x28e9de.text();
    }).then(_0x26e867 => {
      const _0x1a9ef1 = new DOMParser().parseFromString(_0x26e867, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(_0x2af6c9 => {
        _0x2af6c9.cachedResults[_0x2f2d99] = _0x1a9ef1;
      }), this.renderSearchResults(_0x1a9ef1);
    })["catch"](_0x59a1ee => {
      if (_0x59a1ee?.["code"] === 20) return;
      this.close();
      throw _0x59a1ee;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status"), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", true);
  }
  setLiveRegionText(_0x38a338) {
    this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = _0x38a338, setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(_0x43ea46) {
    this.predictiveSearchResults.innerHTML = _0x43ea46, this.setAttribute("results", true), this.setLiveRegionResults(), this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    return this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom, this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px", this.setAttribute("open", true), this.input.setAttribute("aria-expanded", true), this.isOpen = true;
  }
  close(_0x16c924 = false) {
    this.closeResults(_0x16c924), this.isOpen = false;
  }
  closeResults(_0x59d131 = false) {
    _0x59d131 && (this.input.value = "", this.removeAttribute("results"));
    const _0x55c46c = this.querySelector("[aria-selected=\"true\"]");
    if (_0x55c46c) _0x55c46c.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", false), this.resultsMaxHeight = false, this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "dat" + "a-def" + "er";
class CartDrawer extends HTMLElement {
  constructor() {
    super(), this.upsellHandles = this.getUpsellHandles(), this.quantityGifts = document.querySelector(".quantity-gifts"), this.checkForClear(), this.addEventListener("keyup", _0x26527b => _0x26527b.code === "Escape" && this.close()), this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.setHeaderCartIconAccessibility(), this.cartBodyScroll = 0;
  }
  setHeaderCartIconAccessibility() {
    let _0x14ac8d = document.querySelector("#cart-icon-bubble");
    if (!_0x14ac8d) return;
    if (_0x14ac8d.tagName == "DIV") _0x14ac8d = _0x14ac8d.closest(".header__icon--cart");
    if (!_0x14ac8d) return;
    _0x14ac8d.setAttribute("role", "button"), _0x14ac8d.setAttribute("aria-haspopup", "dialog"), _0x14ac8d.addEventListener("click", _0xe81ed4 => {
      _0xe81ed4.preventDefault(), this.open(_0x14ac8d);
    }), _0x14ac8d.addEventListener("keydown", _0x4838b7 => {
      _0x4838b7.code.toUpperCase() === "SPACE" && (_0x4838b7.preventDefault(), this.open(_0x14ac8d));
    });
  }
  open(_0x2df2fd) {
    if (_0x2df2fd) this.setActiveElement(_0x2df2fd);
    const _0x19a4b9 = this.querySelector("[id^=\"Details-\"] summary");
    if (_0x19a4b9 && !_0x19a4b9.hasAttribute("role")) this.setSummaryAccessibility(_0x19a4b9);
    setTimeout(() => {
      this.classList.add("animate", "active");
    }), this.addEventListener("transitionend", () => {
      const _0x5ec884 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
        _0xe27a50 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(_0x5ec884, _0xe27a50);
    }, {
      "once": true
    }), document.body.classList.add("overflow-hidden");
    const _0x8c1496 = this.querySelector("countdown-timer");
    if (_0x8c1496) _0x8c1496.playTimer();
  }
  close() {
    this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const _0x4d1f8d = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift"),
      _0x4e36b2 = [];
    return _0x4d1f8d.forEach(_0x44ecf1 => {
      _0x44ecf1.dataset.handle && _0x4e36b2.push(_0x44ecf1.dataset.handle);
    }), _0x4e36b2;
  }
  oneNonUpellRemaining() {
    const _0xc1998a = this.querySelectorAll(".cart-item");
    let _0x2fe997 = 0;
    return _0xc1998a.forEach(_0x53484d => {
      this.upsellHandles.forEach(_0x40830f => {
        _0x53484d.classList.contains("cart-item--product-" + _0x40830f) && _0x2fe997++;
      });
    }), _0xc1998a.length - _0x2fe997 <= 1;
  }
  checkForClear() {
    const _0x206f61 = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(_0x1089a8 => {
      _0x206f61 ? _0x1089a8.clearCart = true : _0x1089a8.clearCart = false;
    });
  }
  setSummaryAccessibility(_0x3f2641) {
    _0x3f2641.setAttribute("role", "button"), _0x3f2641.setAttribute("aria-expanded", "false"), _0x3f2641.nextElementSibling.getAttribute("id") && _0x3f2641.setAttribute("aria-controls", _0x3f2641.nextElementSibling.id), _0x3f2641.addEventListener("click", _0x124008 => {
      _0x124008.currentTarget.setAttribute("aria-expanded", !_0x124008.currentTarget.closest("details").hasAttribute("open"));
    }), _0x3f2641.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(_0x31c60c, _0x5cb952 = false) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"), this.productId = _0x31c60c.id, this.getSectionsToRender().forEach(_0x973034 => {
      const _0x17d82b = _0x973034.selector ? document.querySelector(_0x973034.selector) : document.getElementById(_0x973034.id);
      if (_0x17d82b) {
        _0x17d82b.innerHTML = this.getSectionInnerHTML(_0x31c60c.sections[_0x973034.id], _0x973034.selector);
        const _0x28561e = _0x17d82b.querySelector(".cart-drawer__body");
        if (_0x28561e) _0x28561e.scrollTop = this.cartBodyScroll;
      }
    }), this.checkForClear();
    const _0x1a650d = this.querySelector("countdown-timer");
    if (_0x1a650d && _0x1a650d.playTimer) _0x1a650d.playTimer();
    let _0xe05ec3 = [],
      _0x4293c9 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(_0x5b3c4e => {
      _0x5b3c4e.getUpdateRequired() && (this.querySelector(".cart-item--product-" + _0x5b3c4e.dataset.handle) ? _0x5b3c4e.dataset.selected === "false" && _0x4293c9.push(_0x5b3c4e) : _0x5b3c4e.dataset.selected === "true" && _0xe05ec3.push(_0x5b3c4e));
    });
    if (_0x4293c9.length > 0) _0x4293c9[0].removeFromCart();else {
      if (_0xe05ec3.length > 0) _0xe05ec3[0].addToCart();else {
        if (this.quantityGifts) this.quantityGifts.initUnlock();
        const _0x14789e = document.querySelectorAll("quantity-break-upsells");
        _0x14789e.forEach(_0x11a388 => {
          _0x11a388.initUnlock();
        });
      }
    }
    validateCartGifts(), setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (_0x5cb952) return;
      this.open();
    });
  }
  getSectionInnerHTML(_0x993c5, _0x5e2e58 = ".shopify-section") {
    let _0x43c9c = new DOMParser().parseFromString(_0x993c5, "text/html").querySelector(_0x5e2e58);
    _0x5e2e58 === "#CartDrawer" && fixParsedHtml(this, _0x43c9c);
    let _0x239b70 = _0x43c9c.innerHTML;
    return _0x239b70;
  }
  getSectionsToRender() {
    return [{
      "id": "cart-drawer",
      "selector": "#CartDrawer"
    }, {
      "id": "cart-icon-bubble"
    }];
  }
  getSectionDOM(_0x2ed27a, _0x1fcb6c = ".shopify-section") {
    return new DOMParser().parseFromString(_0x2ed27a, "text/html").querySelector(_0x1fcb6c);
  }
  setActiveElement(_0x379b89) {
    this.activeElement = _0x379b89;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "body": JSON.stringify({
        "updates": {},
        "sections": ["cart-drawer", "cart-icon-bubble"],
        "sections_url": window.location.pathname
      })
    }).then(_0x348ae1 => _0x348ae1.json()).then(_0xc46a62 => {
      document.querySelector("cart-drawer").renderContents(_0xc46a62, true);
    })["catch"](_0x3ba053 => {
      console.error(_0x3ba053);
    });
  }
  getSectionInnerHTML(_0x24786e, _0x2d5f87) {
    let _0x55ac40 = new DOMParser().parseFromString(_0x24786e, "text/html").querySelector(_0x2d5f87);
    _0x2d5f87 === ".drawer__inner" && fixParsedHtml(this.cartDrawer, _0x55ac40);
    let _0x4dc5ca = _0x55ac40.innerHTML;
    return _0x4dc5ca;
  }
  getSectionsToRender() {
    return [{
      "id": "CartDrawer",
      "section": "cart-drawer",
      "selector": ".drawer__inner"
    }, {
      "id": "cart-icon-bubble",
      "section": "cart-icon-bubble",
      "selector": ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x889b19, _0x24bb72) {
  const _0xebb91 = _0x889b19.querySelector(".cart-drawer__body");
  if (_0xebb91) {
    const _0x1bf401 = document.querySelector("cart-drawer");
    _0x1bf401.cartBodyScroll = _0xebb91.scrollTop;
  }
  const _0x4e5053 = _0x24bb72.querySelector(".cart-timer");
  if (_0x4e5053) {
    oldTimer = _0x889b19.querySelector(".cart-timer");
    if (oldTimer) _0x4e5053.innerHTML = oldTimer.innerHTML;
  }
  const _0x2ad7bc = _0x889b19.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let _0x1bce72 = _0x24bb72.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  _0x2ad7bc.forEach((_0x47c6da, _0x5aa387) => {
    let _0x4ca30f = _0x1bce72[_0x5aa387];
    if (!_0x4ca30f) return;
    if (_0x47c6da.nodeName.toLowerCase() === "cart-drawer-upsell") _0x4ca30f.dataset.selected = _0x47c6da.dataset.selected;
    _0x4ca30f.dataset.id = _0x47c6da.dataset.id, _0x4ca30f.querySelector("[name=\"id\"]").value = _0x47c6da.querySelector("[name=\"id\"]").value;
    if (_0x4ca30f.querySelector(".upsell__image__img")) _0x4ca30f.querySelector(".upsell__image__img").src = _0x47c6da.querySelector(".upsell__image__img").src;
    if (_0x4ca30f.querySelector(".upsell__variant-picker")) {
      const _0x5bf9da = _0x47c6da.querySelectorAll(".select__select");
      _0x4ca30f.querySelectorAll(".select__select").forEach((_0x9673b6, _0x57ea73) => {
        _0x9673b6.value = _0x5bf9da[_0x57ea73].value, _0x9673b6.querySelectorAll("option").forEach(_0x54ca7e => {
          _0x54ca7e.removeAttribute("selected");
          if (_0x54ca7e.value === _0x5bf9da[_0x57ea73].value.trim()) _0x54ca7e.setAttribute("selected", "");
        });
      });
    }
    if (_0x47c6da.dataset.updatePrices === "true") {
      var _0x363478 = _0x4ca30f.querySelector(".upsell__price"),
        _0xfb3684 = _0x47c6da.querySelector(".upsell__price");
      if (_0x363478 && _0xfb3684) _0x363478.innerHTML = _0xfb3684.innerHTML;
    }
  });
}
!customElements.get("product-form") && customElements.define("product-form", class ProductForm extends HTMLElement {
  constructor() {
    super(), this.form = this.querySelector("form"), this.form.addEventListener("submit", this.handleSubmit.bind(this)), this.formIdInput = this.form.querySelector("[name=id]"), this.formIdInput.disabled = false, this.isMain = this.classList.contains("main-product-form"), this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [], this.skipCart = this.formIdInput.dataset.skipCart === "true", this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification"), this.isCartUpsell = this.dataset.isCartUpsell === "true", this.submitButton = this.querySelector("[type=\"submit\"]");
    if (document.querySelector("cart-drawer")) {
      if (this.submitButton) this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.hasDrawer = true;
    }
    if (this.submitButton) this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
    this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section), this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section), this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    if (this.quantityBreaks) this.quantityBreakUpsells = this.quantityBreaks.querySelectorAll("quantity-break-upsells");
    this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section), this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']"), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section), this.variantInputs = this.form.querySelector(".product-form__variants");
  }
  handleSubmit(_0x2884d5) {
    let _0x4d9592 = null,
      _0x68d270 = false;
    _0x2884d5 && (_0x2884d5.preventDefault(), _0x2884d5.currentTarget.classList.contains("button--has-spinner") && (_0x4d9592 = _0x2884d5.currentTarget, _0x4d9592.classList.add("loading")), _0x2884d5.currentTarget.dataset.skipCartButton === "true" && (_0x68d270 = true));
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", true);
    if (!_0x4d9592) {
      this.submitButton.classList.add("loading");
      if (this.loadingSpinner) this.loadingSpinner.classList.remove("hidden");
    }
    this.additionalAtcButtons.forEach(_0x5f1dcc => {
      _0x5f1dcc.setAttribute("disabled", "");
    });
    this.displayedSubmitButton && (this.displayedSubmitButton.setAttribute("disabled", ""), this.displayedSubmitButton.classList.add("loading"));
    let _0x330110 = false,
      _0x5526df = false;
    if (this.variantInputs && !this.ref) {
      this.variantInputs.innerHTML = "";
      let _0x184534 = "";
      const _0x423a23 = [],
        _0x35efb2 = new Set(),
        _0x484764 = _0x994d91 => {
          const _0x515bba = _0x994d91 == null ? "" : String(_0x994d91).trim();
          return _0x515bba === "" ? null : _0x515bba;
        },
        _0x562980 = (_0x50a535, _0x2d8e26 = 1, _0x2c8bd8 = null) => {
          if (!_0x50a535) return;
          const _0x57fa29 = String(_0x50a535),
            _0x51355f = Number(_0x2d8e26) || 1,
            _0x59b8b0 = _0x484764(_0x2c8bd8),
            _0x92ed8 = _0x423a23.findIndex(_0x141a1c => {
              const _0x48aeec = _0x484764(_0x141a1c.selling_plan);
              return _0x141a1c.id === _0x57fa29 && _0x48aeec === _0x59b8b0;
            });
          if (_0x92ed8 === -1) {
            const _0xce317 = {
              "id": _0x57fa29,
              "quantity": _0x51355f
            };
            if (_0x59b8b0) _0xce317.selling_plan = _0x59b8b0;
            _0x423a23.push(_0xce317);
          } else _0x423a23[_0x92ed8].quantity += _0x51355f;
        },
        _0x10f814 = _0x54a7ce => {
          if (_0x54a7ce) _0x35efb2.add(String(_0x54a7ce));
        };
      this.hasDrawer && !this.isCartUpsell && !this.skipCart && this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x2fef57 => {
        if (_0x2fef57.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + _0x2fef57.dataset.handle)) {
          const _0x3ae1f0 = _0x2fef57.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
          _0x562980(_0x2fef57.dataset.id, 1, _0x3ae1f0);
        }
      });
      if (this.bundleDeals) this.dataset.includePdpUpsells === "true" && document.querySelectorAll("product-info-upsell").forEach(_0x43f653 => {
        const _0x422e6c = _0x43f653.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
        if (_0x43f653.dataset.selected === "true") _0x562980(_0x43f653.dataset.id, 1, _0x422e6c);
      }), (this.bundleDeals.formVariants || []).forEach(_0x4cd8a5 => {
        if (!_0x4cd8a5) return;
        _0x562980(_0x4cd8a5.id, Number(_0x4cd8a5.quantity) || 1);
      });else {
        this.quantityGifts && Array.isArray(this.quantityGifts.unlockedItems) && this.quantityGifts.unlockedItems.length > 0 && this.quantityGifts.unlockedItems.forEach(_0x2c8796 => _0x562980(_0x2c8796, 1));
        this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
        for (let _0x4fd0fb = this.upsells.length - 1; _0x4fd0fb >= 0; _0x4fd0fb--) {
          const _0x37db0a = this.upsells[_0x4fd0fb];
          if (_0x37db0a && _0x37db0a.dataset.selected === "true") {
            const _0x55d141 = _0x37db0a.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
            _0x562980(_0x37db0a.dataset.id, 1, _0x55d141);
          }
        }
        this.quantityBreakUpsells && this.quantityBreakUpsells.forEach(_0x49a1e7 => {
          (_0x49a1e7.unlockedItems || []).forEach(_0x1a5053 => {
            const _0x1c859a = String(_0x1a5053);
            !_0x423a23.some(_0xa6eacd => String(_0xa6eacd.id) === _0x1c859a) && _0x562980(_0x1c859a, 1);
          });
        });
        if (this.mainBundleItems.length === 0) {
          if (this.quantityBreaks && Array.isArray(this.quantityBreaks.formVariants) && this.quantityBreaks.formVariants.length > 0) this.quantityBreaks.formVariants.forEach(_0x4d387d => {
            _0x562980(_0x4d387d, 1), _0x10f814(_0x4d387d);
          }), _0x5526df = true;else {
            let _0x1dd8b6 = 1;
            if (this.quantityBreaks) _0x1dd8b6 = Number(this.quantityBreaks.selectedQuantity) || 1;else {
              if (this.quantityPicker) _0x1dd8b6 = Number(this.quantityPicker.querySelector(".quantity__input")?.["value"]) || 1;else this.querySelector("input[name=\"quantity\"]") && (_0x1dd8b6 = Number(this.querySelector("input[name=\"quantity\"]").value) || 1);
            }
            const _0x5d5740 = this.formIdInput.value;
            _0x562980(_0x5d5740, _0x1dd8b6), _0x10f814(_0x5d5740);
          }
        }
        for (let _0x4a7c82 = this.mainBundleItems.length - 1; _0x4a7c82 >= 0; _0x4a7c82--) {
          const _0x2d6d28 = this.mainBundleItems[_0x4a7c82];
          _0x562980(_0x2d6d28.dataset.id, 1), (_0x2d6d28.dataset.isMainPdpProduct === undefined || _0x2d6d28.dataset.isMainPdpProduct === "true") && _0x10f814(_0x2d6d28.dataset.id);
        }
      }
      if (_0x423a23.length > 1 || _0x5526df || this.bundleDeals || this.mainBundleItems.length > 0) {
        const _0x9cd790 = [];
        this.customFields?.["forEach"](_0x350f36 => {
          _0x350f36?.["dataset"]?.["disabled"] !== "true" && _0x9cd790.push({
            "fieldName": _0x350f36.fieldName,
            "value": _0x350f36.prevValue
          });
        });
        let _0x212f90 = null;
        this.classList.contains("main-product-form") && (_0x212f90 = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"], skio-plan-picker [name=\"selling_plan\"]"));
        const _0x349730 = this.querySelector("#simple-bundles-io-options"),
          _0x524790 = "input[name^=\"properties[\"]:not(#validator):not(.shrine-property-input):not([type=\"radio\"])," + "input[name^=\"properties[\"][type=\"radio\"]:checked:not(#validator):not(.shrine-property-input)," + "select[name^=\"properties[\"]:not(#validator):not(.shrine-property-input)",
          _0x19c73d = this.classList.contains("main-product-form") ? this.productInfo ? this.productInfo.querySelectorAll(_0x524790) : document.querySelectorAll(_0x524790) : [];
        _0x423a23.forEach(_0x1ee45a => {
          if (_0x35efb2.has(_0x1ee45a.id)) {
            const _0x5c2146 = [];
            _0x9cd790.forEach(_0x5b8c33 => {
              _0x5c2146.push({
                "fieldName": _0x5b8c33.fieldName,
                "value": _0x5b8c33.value
              });
            });
            _0x349730 && _0x349730.querySelectorAll("select[name^=\"properties[\"], input[name^=\"properties[\"]").forEach(_0x491814 => {
              const _0x413abb = _0x491814.name.match(/properties\[(.*?)\]/);
              if (_0x413abb) _0x5c2146.push({
                "fieldName": _0x413abb[1],
                "value": _0x491814.value
              });
            });
            this.classList.contains("main-product-form") && _0x19c73d.forEach(_0xe992 => {
              const _0x5317c2 = _0xe992.name.match(/properties\[(.*?)\]/);
              _0x5317c2 && (_0xe992.type === "file" ? _0xe992.files && _0xe992.files.length > 0 && _0x5c2146.push({
                "fieldName": _0x5317c2[1],
                "value": _0xe992.files[0],
                "isFile": true
              }) : _0x5c2146.push({
                "fieldName": _0x5317c2[1],
                "value": _0xe992.value
              }));
            });
            if (_0x5c2146.length) _0x1ee45a.properties = _0x5c2146;
            _0x212f90 && typeof _0x212f90.value === "string" && _0x212f90.value.length > 0 && (_0x1ee45a.selling_plan = _0x212f90.value);
          }
        });
        const _0x5b5490 = document.createDocumentFragment(),
          _0x42d29d = [];
        _0x423a23.forEach((_0x4c4a09, _0x2943f7) => {
          _0x184534 += "<input type=\"hidden\" name=\"items[" + _0x2943f7 + "][quantity]\" value=\"" + _0x4c4a09.quantity + "\">" + ("<input type=\"hidden\" name=\"items[" + _0x2943f7 + "][id]\" value=\"" + _0x4c4a09.id + "\">"), _0x4c4a09.selling_plan && (_0x184534 += "<input type=\"hidden\" name=\"items[" + _0x2943f7 + "][selling_plan]\" value=\"" + _0x4c4a09.selling_plan + "\">"), Array.isArray(_0x4c4a09.properties) && _0x4c4a09.properties.length && _0x4c4a09.properties.forEach(_0x131b0b => {
            if (_0x131b0b.isFile) _0x42d29d.push({
              "name": "items[" + _0x2943f7 + "][properties][" + _0x131b0b.fieldName + "]",
              "file": _0x131b0b.value
            });else {
              const _0x569c01 = document.createElement("input");
              _0x569c01.type = "hidden", _0x569c01.name = "items[" + _0x2943f7 + "][properties][" + _0x131b0b.fieldName + "]", _0x569c01.value = serializePropValue(_0x131b0b.value), _0x5b5490.appendChild(_0x569c01);
            }
          });
        }), this._filePropsForFormData = _0x42d29d, this.variantInputs.innerHTML = _0x184534, this.variantInputs.appendChild(_0x5b5490), _0x330110 = true;
      }
    }
    var _0xd679ef = fetchConfig("javascript");
    _0xd679ef.headers["X-Requested-With"] = "XMLHttpRequest", delete _0xd679ef.headers["Content-Type"];
    var _0x38ceb9 = new FormData(this.form);
    this._filePropsForFormData && this._filePropsForFormData.length > 0 && (this._filePropsForFormData.forEach(({
      name: _0x8a5174,
      file: _0x8639d6
    }) => {
      _0x38ceb9.append(_0x8a5174, _0x8639d6);
    }), this._filePropsForFormData = []);
    if (this.ref) _0x330110 = true;
    this.cart && (_0x38ceb9.append("sections", this.cart.getSectionsToRender().map(_0x34df9c => _0x34df9c.id)), _0x38ceb9.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement));
    if (_0x330110) {
      const _0x3bcd37 = this.dataset.options ? this.dataset.options.split(",") : [],
        _0x150eb3 = ["id", "quantity", ..._0x3bcd37];
      for (let _0xe776c7 = 0; _0xe776c7 < _0x150eb3.length; _0xe776c7++) {
        _0x38ceb9["delete"](_0x150eb3[_0xe776c7]);
      }
    }
    _0xd679ef.body = _0x38ceb9, fetch("" + routes.cart_add_url, _0xd679ef).then(_0x366fdb => _0x366fdb.json()).then(async _0x2875ef => {
      if (_0x2875ef.status) {
        this.handleErrorMessage(_0x2875ef.description);
        const _0x46b5bf = this.submitButton.querySelector(".sold-out-message");
        if (!_0x46b5bf) return;
        this.submitButton.setAttribute("aria-disabled", true), this.submitButton.querySelector("span").classList.add("hidden"), _0x46b5bf.classList.remove("hidden"), this.error = true;
        return;
      }
      if (!_0x2875ef.sections && this.cart) try {
        const _0x4366db = await fetch(routes.cart_url + "?sections=" + this.cart.getSectionsToRender().map(_0x113bfe => _0x113bfe.id).join(",")),
          _0x525ca1 = await _0x4366db.text();
        try {
          const _0x45137d = JSON.parse(_0x525ca1);
          _0x2875ef.sections = _0x45137d;
        } catch (_0x1cc457) {
          console.error("Add to cart fallback JSON parse failed", _0x1cc457), window.location = window.routes.cart_url;
          return;
        }
      } catch (_0x1597c7) {
        console.error("Add to cart fallback failed", _0x1597c7), this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
        return;
      }
      if (this.skipCart || _0x68d270) {
        window.location = "/checkout";
        return;
      } else {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
      }
      if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
        "source": "product-form",
        "productVariantId": this.formIdInput.id,
        "cartData": _0x2875ef
      });
      this.error = false;
      const _0x109b99 = this.closest("quick-add-modal");
      _0x109b99 ? (document.body.addEventListener("modalClosed", () => {
        setTimeout(() => {
          this.cart.renderContents(_0x2875ef, this.isCartUpsell);
        });
      }, {
        "once": true
      }), _0x109b99.hide(true)) : this.cart.renderContents(_0x2875ef, this.isCartUpsell);
    })["catch"](_0x5ceb00 => {
      console.error(_0x5ceb00);
    })["finally"](() => {
      if (_0x4d9592) _0x4d9592.classList.remove("loading");else {
        this.submitButton.classList.remove("loading");
        if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
      }
      this.additionalAtcButtons.forEach(_0x196f61 => {
        _0x196f61.removeAttribute("disabled");
      });
      this.displayedSubmitButton && (this.displayedSubmitButton.removeAttribute("disabled"), this.displayedSubmitButton.classList.remove("loading"));
      if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    });
  }
  handleErrorMessage(_0x545beb = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !_0x545beb), _0x545beb && (this.errorMessage.textContent = _0x545beb);
  }
});
function serializePropValue(_0x5343f2) {
  if (_0x5343f2 == null) return "";
  if (typeof _0x5343f2 === "object") try {
    return JSON.stringify(_0x5343f2);
  } catch {
    return String(_0x5343f2);
  }
  return String(_0x5343f2);
}
!customElements.get("product-info") && customElements.define("product-info", class ProductInfo extends HTMLElement {
  constructor() {
    super(), this.deferredMedia = document.querySelector("[" + defMed + "]"), this.input = this.querySelector(".quantity__input"), this.currentVariant = this.querySelector(".product-variant-id"), this.variantSelects = this.querySelector("variant-radios"), this.submitButton = this.querySelector("[type=\"submit\"]"), this.form = this.querySelector("#ProductForm-" + this.dataset.section), this.hasUrl = this.dataset.url !== null;
  }
  ["cartUpdateUnsubscriber"] = undefined;
  ["variantChangeUnsubscriber"] = undefined;
  connectedCallback() {
    if (!this.form) return;
    if (!this.input) return;
    this.quantityForm = this.querySelector(".product-form__quantity");
    if (!this.quantityForm) return;
    this.setQuantityBoundries(), !this.dataset.originalSection && (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))), this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, _0x181394 => {
      const _0x2ba58e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      if (_0x181394.data.sectionId !== _0x2ba58e) return;
      this.updateQuantityRules(_0x181394.data.sectionId, _0x181394.data.html), this.setQuantityBoundries();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
  }
  setQuantityBoundries() {
    const _0x2856e8 = {
      "cartQuantity": this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
      "min": this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
      "max": this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
      "step": this.input.step ? parseInt(this.input.step) : 1
    };
    let _0x1dbe1e = _0x2856e8.min;
    const _0x57c4b8 = _0x2856e8.max === null ? _0x2856e8.max : _0x2856e8.max - _0x2856e8.cartQuantity;
    if (_0x57c4b8 !== null) _0x1dbe1e = Math.min(_0x1dbe1e, _0x57c4b8);
    if (_0x2856e8.cartQuantity >= _0x2856e8.min) _0x1dbe1e = Math.min(_0x1dbe1e, _0x2856e8.step);
    const _0x3eed6e = parseInt(this.input.value) || _0x1dbe1e;
    let _0x3d6faa = _0x3eed6e;
    if (_0x3d6faa < _0x1dbe1e) _0x3d6faa = _0x1dbe1e;
    if (_0x57c4b8 !== null && _0x3d6faa > _0x57c4b8) _0x3d6faa = _0x57c4b8;
    this.input.min = _0x1dbe1e, this.input.max = _0x57c4b8, this.input.value = _0x3d6faa, publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
  fetchQuantityRules() {
    if (!this.currentVariant || !this.currentVariant.value) return;
    this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"), fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(_0x1772f7 => {
      return _0x1772f7.text();
    }).then(_0x3bc4e8 => {
      const _0x4a0762 = new DOMParser().parseFromString(_0x3bc4e8, "text/html");
      this.updateQuantityRules(this.dataset.section, _0x4a0762), this.setQuantityBoundries();
    })["catch"](_0x5970ad => {
      console.error(_0x5970ad);
    })["finally"](() => {
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
    });
  }
  updateQuantityRules(_0x165999, _0x368e39) {
    const _0x1a4b6b = _0x368e39.getElementById("Quantity-Form-" + _0x165999);
    if (_0x1a4b6b && this.quantityForm) {
      const _0x5330a1 = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let _0x316bb8 of _0x5330a1) {
        const _0x381f8c = this.quantityForm.querySelector(_0x316bb8),
          _0xa3b6f7 = _0x1a4b6b.querySelector(_0x316bb8);
        if (!_0x381f8c || !_0xa3b6f7) continue;
        if (_0x316bb8 === ".quantity__input") {
          const _0x163b88 = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let _0x2defef of _0x163b88) {
            const _0x485dd3 = _0xa3b6f7.getAttribute(_0x2defef);
            if (_0x485dd3 !== null) _0x381f8c.setAttribute(_0x2defef, _0x485dd3);
          }
        } else _0x381f8c.innerHTML = _0xa3b6f7.innerHTML;
      }
    }
  }
});
function getFocusableElements(_0x528800) {
  return Array.from(_0x528800.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_0x21713e => {
  _0x21713e.setAttribute("role", "button"), _0x21713e.setAttribute("aria-expanded", _0x21713e.parentNode.hasAttribute("open"));
  _0x21713e.nextElementSibling?.["getAttribute"]("id") && _0x21713e.setAttribute("aria-controls", _0x21713e.nextElementSibling.id);
  _0x21713e.addEventListener("click", _0x5b7436 => {
    _0x5b7436.currentTarget.setAttribute("aria-expanded", !_0x5b7436.currentTarget.closest("details").hasAttribute("open"));
  });
  if (_0x21713e.closest("header-drawer")) return;
  _0x21713e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x57a70c, _0x3fc5aa = _0x57a70c) {
  var _0x3a1407 = getFocusableElements(_0x57a70c),
    _0x2ab790 = _0x3a1407[0],
    _0x2fee46 = _0x3a1407[_0x3a1407.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = _0x5eab75 => {
    if (_0x5eab75.target !== _0x57a70c && _0x5eab75.target !== _0x2fee46 && _0x5eab75.target !== _0x2ab790) return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.keydown = function (_0x1836f7) {
    if (_0x1836f7.code.toUpperCase() !== "TAB") return;
    _0x1836f7.target === _0x2fee46 && !_0x1836f7.shiftKey && (_0x1836f7.preventDefault(), _0x2ab790.focus()), (_0x1836f7.target === _0x57a70c || _0x1836f7.target === _0x2ab790) && _0x1836f7.shiftKey && (_0x1836f7.preventDefault(), _0x2fee46.focus());
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), _0x3fc5aa.focus(), _0x3fc5aa.tagName === "INPUT" && ["search", "text", "email", "url"].includes(_0x3fc5aa.type) && _0x3fc5aa.value && _0x3fc5aa.setSelectionRange(0, _0x3fc5aa.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(_0x5a866e => {
    _0x5a866e.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"" + "pauseVideo" + "\",\"args\":\"\"}", "*");
  }), document.querySelectorAll(".js-vimeo").forEach(_0x57d3ed => {
    _0x57d3ed.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  }), document.querySelectorAll("media-gallery template video").forEach(_0x17e371 => _0x17e371.pause()), document.querySelectorAll("product-model").forEach(_0x240fbd => {
    if (_0x240fbd.modelViewerUI) _0x240fbd.modelViewerUI.pause();
  });
}
function removeTrapFocus(_0x493cc3 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x493cc3) _0x493cc3.focus();
}
function onKeyUpEscape(_0x1010ab) {
  if (_0x1010ab.code.toUpperCase() !== "ESCAPE") return;
  const _0x80f40c = _0x1010ab.target.closest("details[open]");
  if (!_0x80f40c) return;
  const _0x65fe89 = _0x80f40c.querySelector("summary");
  _0x80f40c.removeAttribute("open"), _0x65fe89.setAttribute("aria-expanded", false), _0x65fe89.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      "bubbles": true
    }), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll("button").forEach(_0x3511c5 => _0x3511c5.addEventListener("click", this.onButtonClick.bind(this)));
  }
  ["quantityUpdateUnsubscriber"] = undefined;
  connectedCallback() {
    this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(_0x54aeed) {
    this.validateQtyRules();
  }
  onButtonClick(_0xff94c5) {
    _0xff94c5.preventDefault();
    const _0xe653ec = this.input.value;
    _0xff94c5.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (_0xe653ec !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const _0x5cfe85 = parseInt(this.input.value);
    if (this.input.min) {
      const _0x384d28 = parseInt(this.input.min),
        _0x4b49b2 = this.querySelector(".quantity__button[name='minus']");
      _0x4b49b2.classList.toggle("disabled", _0x5cfe85 <= _0x384d28);
    }
    if (this.input.max) {
      const _0x2069c4 = parseInt(this.input.max),
        _0x3a131e = this.querySelector(".quantity__button[name='plus']");
      _0x3a131e.classList.toggle("disabled", _0x5cfe85 >= _0x2069c4);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) this.quantityGifts.unlockGifts(_0x5cfe85);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x340c66, _0x5eeac6) {
  let _0x5b98df;
  return (..._0x1e3bfe) => {
    clearTimeout(_0x5b98df), _0x5b98df = setTimeout(() => _0x340c66.apply(this, _0x1e3bfe), _0x5eeac6);
  };
}
function fetchConfig(_0xbfe12f = "json") {
  return {
    "method": "POST",
    "headers": {
      "Content-Type": "application/json",
      "Accept": "application/" + _0xbfe12f
    }
  };
}
function addDays(_0x489fe5, _0x51e308) {
  var _0x5c359d = new Date(_0x489fe5);
  return _0x5c359d.setDate(_0x5c359d.getDate() + _0x51e308), _0x5c359d;
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function (_0x1baf6b, _0x368b3d) {
  return function () {
    return _0x1baf6b.apply(_0x368b3d, arguments);
  };
}, Shopify.setSelectorByValue = function (_0x5ce256, _0x365070) {
  for (var _0x32ecf6 = 0, _0x5aa688 = _0x5ce256.options.length; _0x32ecf6 < _0x5aa688; _0x32ecf6++) {
    var _0x267bd6 = _0x5ce256.options[_0x32ecf6];
    if (_0x365070 == _0x267bd6.value || _0x365070 == _0x267bd6.innerHTML) return _0x5ce256.selectedIndex = _0x32ecf6, _0x32ecf6;
  }
}, Shopify.addListener = function (_0x41b5a4, _0x26a2c6, _0xace901) {
  _0x41b5a4.addEventListener ? _0x41b5a4.addEventListener(_0x26a2c6, _0xace901, false) : _0x41b5a4.attachEvent("on" + _0x26a2c6, _0xace901);
}, Shopify.postLink = function (_0x2eaf77, _0x3bc8d1) {
  _0x3bc8d1 = _0x3bc8d1 || {};
  var _0x48ebe8 = _0x3bc8d1.method || "post",
    _0x24c526 = _0x3bc8d1.parameters || {},
    _0x4690a8 = document.createElement("form");
  _0x4690a8.setAttribute("method", _0x48ebe8), _0x4690a8.setAttribute("action", _0x2eaf77);
  for (var _0x43d399 in _0x24c526) {
    var _0x2ef94a = document.createElement("input");
    _0x2ef94a.setAttribute("type", "hidden"), _0x2ef94a.setAttribute("name", _0x43d399), _0x2ef94a.setAttribute("value", _0x24c526[_0x43d399]), _0x4690a8.appendChild(_0x2ef94a);
  }
  document.body.appendChild(_0x4690a8), _0x4690a8.submit(), document.body.removeChild(_0x4690a8);
}, Shopify.CountryProvinceSelector = function (_0x1d12d, _0x1bd547, _0xfa49eb) {
  this.countryEl = document.getElementById(_0x1d12d), this.provinceEl = document.getElementById(_0x1bd547), this.provinceContainer = document.getElementById(_0xfa49eb.hideElement || _0x1bd547), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince();
}, Shopify.CountryProvinceSelector.prototype = {
  "initCountry": function () {
    var _0x2ef888 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, _0x2ef888), this.countryHandler();
  },
  "initProvince": function () {
    var _0x2f9795 = this.provinceEl.getAttribute("data-default");
    _0x2f9795 && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, _0x2f9795);
  },
  "countryHandler": function (_0x273ff4) {
    var _0xa6481e = this.countryEl.options[this.countryEl.selectedIndex],
      _0xa817f = _0xa6481e.getAttribute("data-provinces"),
      _0x501521 = JSON.parse(_0xa817f);
    this.clearOptions(this.provinceEl);
    if (_0x501521 && _0x501521.length == 0) this.provinceContainer.style.display = "none";else {
      for (var _0x2d54c9 = 0; _0x2d54c9 < _0x501521.length; _0x2d54c9++) {
        var _0xa6481e = document.createElement("option");
        _0xa6481e.value = _0x501521[_0x2d54c9][0], _0xa6481e.innerHTML = _0x501521[_0x2d54c9][1], this.provinceEl.appendChild(_0xa6481e);
      }
      this.provinceContainer.style.display = "";
    }
  },
  "clearOptions": function (_0x4d96c6) {
    while (_0x4d96c6.firstChild) {
      _0x4d96c6.removeChild(_0x4d96c6.firstChild);
    }
  },
  "setOptions": function (_0x2b611f, _0x19e8e5) {
    for (var _0x3a8160 = 0, _0x1be41b = _0x19e8e5.length; _0x3a8160 < _0x19e8e5.length; _0x3a8160++) {
      var _0x31fc93 = document.createElement("option");
      _0x31fc93.value = _0x19e8e5[_0x3a8160], _0x31fc93.innerHTML = _0x19e8e5[_0x3a8160], _0x2b611f.appendChild(_0x31fc93);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super(), this.playButton = this.querySelector(".internal-video__play"), this.noPlayBtn = this.dataset.noPlayBtn === "true", this.loaded = false, this.suspended = false, this.soundButton = this.querySelector(".internal-video__sound-btn"), this.video = this.querySelector("video"), this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector(".internal-video__timeline"), this.dragging = false, this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn");
    if (this.playButton) this.playButton.addEventListener("click", this.playVideo.bind(this));
    if (this.soundButton) this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    if (this.video) this.video.addEventListener("ended", this.endedVideo.bind(this));
    this.timeline && (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)), this.timeline.addEventListener("click", this.seekVideo.bind(this)), this.timeline.addEventListener("mousedown", this.startDrag.bind(this)), this.timeline.addEventListener("touchstart", this.startDrag.bind(this)), document.addEventListener("mouseup", this.stopDrag.bind(this)), document.addEventListener("touchend", this.stopDrag.bind(this)), document.addEventListener("mousemove", this.drag.bind(this)), document.addEventListener("touchmove", this.drag.bind(this)));
    this.video.addEventListener("waiting", this.showSpinner.bind(this)), this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this)), this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const _0x2415e7 = {
        "root": null,
        "rootMargin": "0px",
        "threshold": 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0x2415e7), this.observer.observe(this);
    }
    this.fullscreenButton && (this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this)), document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this)));
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), this.loaded = true);
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      const _0x54b030 = this.video.play();
      _0x54b030 !== undefined && _0x54b030.then(() => {
        this.classList.add("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      })["catch"](_0x375fde => {
        this.classList.remove("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
      });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted ? (this.video.muted = false, this.classList.remove("internal-video--muted")) : (this.video.muted = true, this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const _0x3d0005 = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", _0x3d0005 + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(_0x11da09) {
    _0x11da09.preventDefault(), this.dragging = true, this.drag(_0x11da09);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(_0x4d5190) {
    if (!this.dragging) return;
    _0x4d5190.touches && (_0x4d5190 = _0x4d5190.touches[0]), this.seekVideo(_0x4d5190);
  }
  seekVideo(_0x9f5e88) {
    const _0xbc0ff5 = this.timeline.getBoundingClientRect(),
      _0x2def97 = _0x9f5e88.clientX - _0xbc0ff5.left,
      _0x23da33 = _0x2def97 / _0xbc0ff5.width;
    this.video.currentTime = _0x23da33 * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(_0x3cf8f3) {
    _0x3cf8f3.forEach(_0x49f129 => {
      if (_0x49f129.isIntersecting) {
        for (let _0x352398 of this.video.querySelectorAll("source[data-src]")) {
          _0x352398.setAttribute("src", _0x352398.getAttribute("data-src")), _0x352398.removeAttribute("data-src");
        }
        this.video.load();
        var _0x1eff52 = this.video.play();
        _0x1eff52 !== undefined && _0x1eff52["catch"](_0x517365 => {
          if (_0x517365.name === "NotAllowedError") {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
          }
        }).then(() => {
          this.video.play();
        }), this.observer.disconnect();
      }
    });
  }
  toggleFullscreen() {
    document.fullscreenElement ? document.exitFullscreen() : this.requestFullscreen();
  }
  handleFullscreenChange() {
    document.fullscreenElement === this ? this.classList.add("internal-video--fullscreen") : this.classList.remove("internal-video--fullscreen");
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(), this.sliderOverlay = this.querySelector(".comparison-slider__overlay"), this.sliderLine = this.querySelector(".comparison-slider__line"), this.sliderInput = this.querySelector(".comparison-slider__input"), this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(_0x51a842) {
    const _0x48e2d5 = _0x51a842.currentTarget.value;
    this.sliderOverlay.style.width = _0x48e2d5 + "%", this.sliderLine.style.left = _0x48e2d5 + "%", this.style.setProperty("--position", _0x48e2d5 + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super(), this.testMode = this.dataset.testMode === "true", this.secondsDelay = this.dataset.delaySeconds, this.daysFrequency = this.dataset.delayDays, this.modal = this.querySelector(".sign-up-popup-modal"), this.timer = this.querySelector(".popup-modal__timer"), this.timerDuration = this.dataset.timerDuration, this.closeBtns = this.querySelectorAll(".promp-popup__close-btn"), this.overlay = document.querySelector(".sign-up-popup-overlay"), this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();else {
        const _0x1066c6 = JSON.parse(localStorage.getItem(this.storageKey)),
          _0xc2925a = new Date(_0x1066c6.next_display_date);
        currentDate.getTime() > _0xc2925a.getTime() && this.openPopupModal();
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach(_0x5d685a => {
      _0x5d685a.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
      const _0x28566d = addDays(currentDate, parseInt(this.daysFrequency)),
        _0x13690b = {
          "next_display_date": _0x28566d,
          "dismissed": false
        };
      localStorage.setItem(this.storageKey, JSON.stringify(_0x13690b));
      if (this.timer) this.displayPromoTimer();
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes"), this.secondsSpan = this.querySelector(".popup-modal__timer__seconds"), this.totalSeconds = parseFloat(this.timerDuration) * 60, this.updateTimer();
    const _0x285a30 = setInterval(() => {
      this.totalSeconds -= 1, this.updateTimer(), this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1000);
  }
  updateTimer() {
    let _0x841d3e = Math.floor(this.totalSeconds / 60);
    if (_0x841d3e.toString().length === 1) _0x841d3e = "0" + _0x841d3e;
    let _0x457a69 = this.totalSeconds % 60;
    if (_0x457a69.toString().length === 1) _0x457a69 = "0" + _0x457a69;
    this.minutesSpan.innerText = _0x841d3e, this.secondsSpan.innerText = _0x457a69;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super(), this.sectionOneContainer = this.querySelector(".section-group__section-one-container"), this.sectionTwoContainer = this.querySelector(".section-group__section-two-container"), this.transferSections(), document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping"), this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector(".clickable-discount__btn"), this.button.addEventListener("click", this.handleClick.bind(this)), this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = "true", this.button.disabled = true, this.dataset.error = "false", fetch("/discount/" + this.dataset.code).then(_0x5cfb49 => {
      if (!_0x5cfb49.ok) throw new Error("Error");
      this.dataset.applied = "true", sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    })["catch"](_0x4c2d15 => {
      this.dataset.error = "true", this.button.disabled = false;
    })["finally"](() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const _0x39b587 = this.dataset.code;
    sessionStorage.getItem("discount-" + _0x39b587 + "-applied") && (this.dataset.applied = "true", this.button.disabled = true, setTimeout(() => {
      fetch("/discount/" + _0x39b587)["catch"](_0x40fdd6 => {
        this.dataset.applied = "false", this.button.disabled = false;
      });
    }, 3000));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(), this.dateFormat = this.dataset.dateFormat, this.days = this.rearrangeDays(this.dataset.dayLabels.split(",")), this.months = this.dataset.monthLabels.split(","), this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]"), this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || ""), this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || ""), this.insertDates(), document.addEventListener("shopify:section:load", _0x47935a => {
      this.insertDates();
    });
  }
  addDaysSkipping(_0x490712, _0x233317) {
    let _0x51d5f6 = new Date(_0x490712),
      _0x21c736 = Number(_0x233317) || 0;
    while (_0x21c736 > 0) {
      _0x51d5f6 = addDays(_0x51d5f6, 1);
      if (!this.isSkipped(_0x51d5f6)) _0x21c736--;
    }
    return _0x51d5f6;
  }
  parseDaysToSkip(_0x2831ae) {
    const _0x168d9f = new Map([["sunday", 0], ["monday", 1], ["tuesday", 2], ["wednesday", 3], ["thursday", 4], ["friday", 5], ["saturday", 6]]),
      _0x20a72b = new Set();
    if (!_0x2831ae) return _0x20a72b;
    return _0x2831ae.split(",").forEach(_0x16fd9e => {
      const _0x33ac8b = _0x16fd9e.trim();
      if (_0x168d9f.has(_0x33ac8b)) _0x20a72b.add(_0x168d9f.get(_0x33ac8b));
    }), _0x20a72b;
  }
  parseDatesToSkip(_0x3cf6b3) {
    const _0x1af9d5 = new Set();
    if (!_0x3cf6b3) return _0x1af9d5;
    return _0x3cf6b3.split(",").forEach(_0x22ef3d => {
      const _0x59a230 = _0x22ef3d.trim();
      if (!_0x59a230) return;
      const _0x3193f7 = _0x59a230.split("-");
      if (_0x3193f7.length === 2) {
        const _0xdaeb02 = String(Math.max(1, Math.min(12, Number(_0x3193f7[0])))).padStart(2, "0"),
          _0x4d1c6b = String(Math.max(1, Math.min(31, Number(_0x3193f7[1])))).padStart(2, "0");
        _0x1af9d5.add(_0xdaeb02 + "-" + _0x4d1c6b);
      } else {
        if (_0x3193f7.length === 3) {
          const _0x5734d6 = String(Math.max(1, Math.min(12, Number(_0x3193f7[1])))).padStart(2, "0"),
            _0x3b727b = String(Math.max(1, Math.min(31, Number(_0x3193f7[2])))).padStart(2, "0");
          _0x1af9d5.add(_0x5734d6 + "-" + _0x3b727b);
        }
      }
    }), _0x1af9d5;
  }
  isSkipped(_0x55f8a5) {
    const _0x58d24a = this.daysToSkip.has(_0x55f8a5.getDay()),
      _0x2baed6 = String(_0x55f8a5.getMonth() + 1).padStart(2, "0"),
      _0x5af282 = String(_0x55f8a5.getDate()).padStart(2, "0"),
      _0x2e7b19 = this.datesToSkip.has(_0x2baed6 + "-" + _0x5af282);
    return _0x58d24a || _0x2e7b19;
  }
  nextValidDate(_0x54364b) {
    let _0x4c5580 = new Date(_0x54364b);
    while (this.isSkipped(_0x4c5580)) {
      _0x4c5580 = addDays(_0x4c5580, 1);
    }
    return _0x4c5580;
  }
  insertDates() {
    this.elementsToChange.forEach(_0x590139 => {
      const _0x41dae8 = _0x590139.dataset.text,
        _0x48e958 = parseInt(_0x590139.dataset.minDays),
        _0x161b19 = parseInt(_0x590139.dataset.maxDays),
        _0x53e27b = this.addDaysSkipping(currentDate, _0x48e958),
        _0x3b81cb = this.addDaysSkipping(currentDate, _0x161b19);
      let _0x1f571d = "th";
      const _0x23e590 = _0x53e27b.getDate();
      if ([1, 21, 31].includes(_0x23e590)) _0x1f571d = "st";else {
        if ([2, 22].includes(_0x23e590)) _0x1f571d = "nd";else {
          if ([3, 23].includes(_0x23e590)) _0x1f571d = "rd";
        }
      }
      let _0x3950c7 = "th";
      const _0x2c5226 = _0x3b81cb.getDate();
      if ([1, 21, 31].includes(_0x2c5226)) _0x3950c7 = "st";else {
        if ([2, 22].includes(_0x2c5226)) _0x3950c7 = "nd";else {
          if ([3, 23].includes(_0x2c5226)) _0x3950c7 = "rd";
        }
      }
      let _0x5d13a2, _0x19e9eb;
      if (this.dateFormat === "day_dd_mm") _0x5d13a2 = this.days[_0x53e27b.getDay()] + ", " + _0x53e27b.getDate() + ". " + this.months[_0x53e27b.getMonth()], _0x19e9eb = this.days[_0x3b81cb.getDay()] + ", " + _0x3b81cb.getDate() + ". " + this.months[_0x3b81cb.getMonth()];else {
        if (this.dateFormat === "mm_dd") _0x5d13a2 = this.months[_0x53e27b.getMonth()] + " " + _0x53e27b.getDate() + _0x1f571d, _0x19e9eb = this.months[_0x3b81cb.getMonth()] + " " + _0x3b81cb.getDate() + _0x3950c7;else {
          if (this.dateFormat === "dd_mm") _0x5d13a2 = _0x53e27b.getDate() + ". " + this.months[_0x53e27b.getMonth()], _0x19e9eb = _0x3b81cb.getDate() + ". " + this.months[_0x3b81cb.getMonth()];else {
            if (this.dateFormat === "dd_mm_no_dot") _0x5d13a2 = _0x53e27b.getDate() + " " + this.months[_0x53e27b.getMonth()], _0x19e9eb = _0x3b81cb.getDate() + " " + this.months[_0x3b81cb.getMonth()];else {
              if (this.dateFormat === "day_dd_mm_numeric") {
                const _0x75395d = String(_0x53e27b.getDate()).padStart(2, "0"),
                  _0x4743f7 = String(_0x53e27b.getMonth() + 1).padStart(2, "0");
                _0x5d13a2 = this.days[_0x53e27b.getDay()] + ", " + _0x75395d + ". " + _0x4743f7 + ".";
                const _0x23fdc1 = String(_0x3b81cb.getDate()).padStart(2, "0"),
                  _0x15f8ef = String(_0x3b81cb.getMonth() + 1).padStart(2, "0");
                _0x19e9eb = this.days[_0x3b81cb.getDay()] + ", " + _0x23fdc1 + ". " + _0x15f8ef + ".";
              } else {
                if (this.dateFormat === "dd_mm_numeric") {
                  const _0x310635 = String(_0x53e27b.getDate()).padStart(2, "0"),
                    _0x4040ff = String(_0x53e27b.getMonth() + 1).padStart(2, "0");
                  _0x5d13a2 = _0x310635 + ". " + _0x4040ff + ".";
                  const _0x174ca5 = String(_0x3b81cb.getDate()).padStart(2, "0"),
                    _0x494692 = String(_0x3b81cb.getMonth() + 1).padStart(2, "0");
                  _0x19e9eb = _0x174ca5 + ". " + _0x494692 + ".";
                } else _0x5d13a2 = this.days[_0x53e27b.getDay()] + ", " + this.months[_0x53e27b.getMonth()] + " " + _0x53e27b.getDate() + _0x1f571d, _0x19e9eb = this.days[_0x3b81cb.getDay()] + ", " + this.months[_0x3b81cb.getMonth()] + " " + _0x3b81cb.getDate() + _0x3950c7;
              }
            }
          }
        }
      }
      const _0x54ffcd = _0x41dae8.replace("[start_date]", _0x5d13a2),
        _0x5b8457 = _0x54ffcd.replace("[end_date]", _0x19e9eb);
      _0x590139.innerHTML = _0x5b8457;
    });
  }
  rearrangeDays(_0x1cce64) {
    return _0x1cce64.unshift(_0x1cce64[6]), _0x1cce64.length = 7, _0x1cce64;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(), this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === "true" ? "after_scroll" : "always"), this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0), this.isScrollBtn = this.dataset.scrollBtn === "true", this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section), this.floatingBtns = document.querySelectorAll(".floating-btn"), this.footerSpacing();
    this.displayMode === "always" ? this.floatingBtns.forEach(_0x37a2e9 => {
      _0x37a2e9.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
    }) : (this.checkScroll(), document.addEventListener("scroll", this.checkScroll.bind(this)));
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn"), this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
    }
  }
  checkScroll() {
    let _0x250813 = false;
    if (this.displayMode === "after_scroll") {
      if (!this.mainAtcBtn) return;
      const _0x325b6b = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY,
        _0x28c87e = _0x325b6b + this.mainAtcBtn.offsetHeight;
      _0x250813 = window.scrollY > _0x28c87e;
    } else {
      if (this.displayMode === "after_pixels") _0x250813 = window.scrollY > this.displayThreshold;else {
        if (this.displayMode === "after_percent") {
          const _0x16462d = document.documentElement.scrollHeight - window.innerHeight;
          _0x250813 = _0x16462d <= 0 ? true : window.scrollY / _0x16462d * 100 > this.displayThreshold;
        }
      }
    }
    _0x250813 ? (this.style.transform = "none", this.scrolledPast = true) : (this.style.transform = "", this.scrolledPast = false), this.floatingBtns.forEach(_0x447f33 => {
      _0x447f33.style.setProperty("--sticky-atc-offset", this.scrolledPast ? this.offsetHeight + "px" : "0px");
    });
  }
  handleScrollBtn() {
    const _0x10d49c = document.querySelector("sticky-header"),
      _0x2705e3 = _0x10d49c ? _0x10d49c.clientHeight : 0,
      _0x506852 = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      "top": _0x506852 - _0x2705e3 - 15,
      "behavior": "smooth"
    });
  }
  footerSpacing() {
    let _0x542173 = document.querySelector(".sticky-atc-footer-spacer");
    if (_0x542173) return;
    _0x542173 = document.createElement("div"), _0x542173.className = "sticky-atc-footer-spacer", _0x542173.style.height = this.clientHeight - 1 + "px", _0x542173.style.display = "block";
    const _0x5f54c8 = document.querySelector(".footer");
    if (_0x5f54c8) _0x542173.style.background = window.getComputedStyle(_0x5f54c8).background;
    document.body.appendChild(_0x542173);
  }
}
customElements.define("sticky-atc", StickyAtc);
class BundleDeals extends HTMLElement {
  constructor() {
    super(), this.productContainers = this.querySelectorAll(".bundle-deals__product-js"), this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js"), this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js"), this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js"), this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js"), this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.prices = this.querySelectorAll(".bundle-deals__price-js"), this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js"), this.totalPrice = this.querySelector(".bundle-deals__total-price-js"), this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js"), this.updatePrices = this.dataset.updatePrices === "true", this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.currencySymbol = this.dataset.currencySymbol, this.selectedVariants = {
      "id_1": null,
      "id_2": null,
      "id_3": null,
      "id_4": null,
      "id_5": null
    }, this.formVariants = [], this.initIds(), this.checkboxes.forEach(_0x5933ed => {
      _0x5933ed.addEventListener("change", this.handleCheckboxChange.bind(this));
    }), this.variantPickers.forEach(_0x4b7add => {
      _0x4b7add.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(_0x3e7cc1 => {
      this.selectedVariants[_0x3e7cc1.dataset.idIndex] = {
        "id": _0x3e7cc1.dataset.id,
        "price": _0x3e7cc1.dataset.price,
        "comparePrice": _0x3e7cc1.dataset.comparePrice,
        "checked": true
      };
    }), this.updateFormIds();
  }
  handleCheckboxChange(_0x341b4f) {
    const _0x4f79cd = _0x341b4f.currentTarget,
      _0x1383b9 = _0x4f79cd.checked,
      _0x563e16 = parseInt(_0x4f79cd.dataset.index);
    this.selectedVariants[_0x4f79cd.dataset.idIndex].checked = _0x1383b9;
    const _0x28f8c8 = this.productContainers[_0x563e16],
      _0x39c7a1 = _0x28f8c8.querySelectorAll("select");
    _0x1383b9 ? (this.mediaItemContainers[_0x563e16].classList.remove("bundle-deals__media-item--disabled"), _0x28f8c8.classList.remove("bundle-deals__product--deselected"), _0x39c7a1.forEach(_0x56da43 => {
      _0x56da43.removeAttribute("disabled");
    })) : (this.mediaItemContainers[_0x563e16].classList.add("bundle-deals__media-item--disabled"), _0x28f8c8.classList.add("bundle-deals__product--deselected"), _0x39c7a1.forEach(_0x4483ac => {
      _0x4483ac.setAttribute("disabled", "");
    }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(_0x4eea42) {
    const _0x3fab09 = _0x4eea42.currentTarget,
      _0x329d0b = parseInt(_0x3fab09.dataset.index),
      _0x5894b4 = Array.from(_0x3fab09.querySelectorAll("select"), _0x300959 => _0x300959.value),
      _0x1ef3b2 = JSON.parse(_0x3fab09.querySelector("[type=\"application/json\"]").textContent).filter(_0x197aa6 => _0x3fab09.querySelector(":checked").value === _0x197aa6.option1),
      _0x10fb8c = [..._0x3fab09.querySelectorAll(".select--small")];
    updateVariantStatuses(_0x1ef3b2, _0x10fb8c, this.skipUnavailable);
    const _0x104d94 = JSON.parse(_0x3fab09.querySelector("[type=\"application/json\"]").textContent).find(_0xddfced => {
      return !_0xddfced.options.map((_0x4685e4, _0x54853a) => {
        return _0x5894b4[_0x54853a] === _0x4685e4;
      }).includes(false);
    });
    if (!_0x104d94) {
      if (this.skipNonExistent) findAvailableVariant(_0x3fab09, _0x5894b4, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !_0x104d94.available) {
      if (findAvailableVariant(_0x3fab09, _0x5894b4, false, true, true)) return;
    }
    let {
      price: _0x11f346,
      compare_at_price: _0xfc25e5,
      featured_image: _0x1e632b
    } = _0x104d94;
    _0x11f346 = parseInt(_0x11f346);
    let _0x21ada8 = _0xfc25e5 ? parseInt(_0xfc25e5) : _0x11f346;
    const _0x173496 = _0x3fab09.dataset.percentageLeft ?? 1,
      _0x315182 = _0x3fab09.dataset.fixedDiscount ?? 0;
    _0x11f346 = _0x11f346 * _0x173496 - _0x315182;
    if (_0x1e632b) _0x1e632b = _0x1e632b.src;
    const _0x31d25c = _0x104d94.id;
    this.selectedVariants[_0x3fab09.dataset.idIndex].id = _0x31d25c, this.selectedVariants[_0x3fab09.dataset.idIndex].price = _0x11f346, this.selectedVariants[_0x3fab09.dataset.idIndex].comparePrice = _0x21ada8, this.updateFormIds(), this.updatePrices && (this.prices[_0x329d0b].innerHTML = this.currencySymbol + (_0x11f346 / 100).toFixed(2), _0x21ada8 > _0x11f346 ? this.comparePrices[_0x329d0b].innerHTML = this.currencySymbol + (_0x21ada8 / 100).toFixed(2) : this.comparePrices[_0x329d0b].innerHTML = "", this.updateTotalPrice()), _0x1e632b && _0x1e632b.length > 0 && this.mediaItemImgs[_0x329d0b] && (this.mediaItemImgs[_0x329d0b].src = _0x1e632b);
  }
  updateFormIds() {
    const _0x295b5 = [],
      _0x4188dd = this.selectedVariants;
    for (const _0x11fc9d in _0x4188dd) {
      const _0x5bea14 = _0x4188dd[_0x11fc9d];
      if (_0x5bea14 != null && _0x5bea14.checked) {
        const _0xaa0cfb = _0x295b5.findIndex(_0x4269f0 => _0x4269f0.id === _0x5bea14.id);
        _0xaa0cfb < 0 ? _0x295b5.unshift({
          "id": _0x5bea14.id,
          "quantity": 1
        }) : _0x295b5[_0xaa0cfb].quantity += 1;
      }
    }
    this.formVariants = _0x295b5;
  }
  updateTotalPrice() {
    const _0xd2f32c = [],
      _0x3e8901 = [],
      _0x936a3c = this.selectedVariants;
    for (const _0x4f3656 in _0x936a3c) {
      const _0x26fc41 = _0x936a3c[_0x4f3656];
      _0x26fc41 != null && _0x26fc41.checked && (_0xd2f32c.push(parseInt(_0x26fc41.price)), _0x3e8901.push(parseInt(_0x26fc41.comparePrice)));
    }
    const _0x13197a = _0xd2f32c.reduce((_0x41d1e7, _0x98f2fd) => _0x41d1e7 + _0x98f2fd, 0),
      _0x14ea84 = _0x13197a * this.percentageLeft - this.fixedDiscount,
      _0x30f11a = _0x3e8901.reduce((_0x1b81d7, _0x176892) => _0x1b81d7 + _0x176892, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (_0x14ea84 / 100).toFixed(2), _0x30f11a > _0x14ea84 ? this.totalComparePrice.innerHTML = this.currencySymbol + (_0x30f11a / 100).toFixed(2) : this.totalComparePrice.innerHTML = "";
  }
}
customElements.define("bundle-deals", BundleDeals);
function _qbGetPresentmentRate(_0x55d1ab) {
  if (!_0x55d1ab) return null;
  const _0x56dc66 = window.Shopify;
  if (!_0x56dc66 || !_0x56dc66.currency) return null;
  const _0x16cbb5 = _0x56dc66.currency.active,
    _0x486382 = parseFloat(_0x56dc66.currency.rate);
  if (!_0x16cbb5 || !_0x486382 || _0x486382 === 1) return null;
  if (_0x16cbb5 === _0x55d1ab) return null;
  return _0x486382;
}
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells"), this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section), this.inputs = this.querySelectorAll("input[name=\"quantity\"]"), this.labels = this.querySelectorAll(".quantity-break"), this.jsonData = this.querySelector("[type=\"application/json\"]"), this.hasVariants = this.jsonData.dataset.hasVariants === "true", this.selectedVariants = {
      "input_1": [],
      "input_2": [],
      "input_3": [],
      "input_4": [],
      "input_5": [],
      "input_6": []
    }, this.updateUnavailable = this.dataset.updateUnavailable === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.formVariants = [], this.selectedQuantity = 1, this.selectedOffer = 1;
    const _0x206325 = this.querySelector("input[checked]");
    _0x206325 && (this.selectedQuantity = parseInt(_0x206325.value), this.selectedOffer = parseInt(_0x206325.dataset.input.replace("input_", "")));
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePdpPrices = this.dataset.updatePdpPrices === "true", this.moneyFormat = this.dataset.moneyFormat, this.subDiscount = 0, this.subDiscountType = null, this.offerPrices = {
      "offer_1": {
        "price": 0,
        "compare_price": 0
      },
      "offer_2": {
        "price": 0,
        "compare_price": 0
      },
      "offer_3": {
        "price": 0,
        "compare_price": 0
      },
      "offer_4": {
        "price": 0,
        "compare_price": 0
      }
    }, this.initOfferPrices();
    if (this.dataset.currencyConversion === "true") {
      const _0x4a861f = _qbGetPresentmentRate(this.dataset.shopCurrency);
      _0x4a861f && (this.labels.forEach(_0x1a01db => {
        _0x1a01db.dataset.fixedDiscount && (_0x1a01db.dataset.fixedDiscount = String(Math.round(parseFloat(_0x1a01db.dataset.fixedDiscount) * _0x4a861f)));
      }), this.initOfferPrices());
    }
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach(_0x4c0871 => {
      _0x4c0871.addEventListener("change", this.handleChange.bind(this));
    }), this.variantSelects.forEach(_0x2448b8 => {
      _0x2448b8.addEventListener("change", this.handleSelectChange.bind(this));
    });
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  applySubTo(_0xa7c5b2) {
    if (!this.subDiscountType || !_0xa7c5b2) return _0xa7c5b2;
    if (this.subDiscountType === "fixed_amount") return Math.max(0, _0xa7c5b2 - this.subDiscount);else {
      if (this.subDiscountType === "percentage") return Math.round(_0xa7c5b2 * (100 - this.subDiscount) / 100);else {
        if (this.subDiscountType === "price") return this.subDiscount;
      }
    }
    return _0xa7c5b2;
  }
  initOfferPrices() {
    const _0x4b4648 = parseInt(this.dataset.basePrice);
    this.labels.forEach(_0x5e7e41 => {
      const _0x1c22b4 = _0x5e7e41.dataset.input.replace("input_", ""),
        _0x30208a = parseInt(_0x5e7e41.dataset.quantity),
        _0x48b038 = parseFloat(_0x5e7e41.dataset.percentageLeft),
        _0x174aa3 = parseFloat(_0x5e7e41.dataset.fixedDiscount),
        _0x429664 = _0x4b4648 * _0x30208a * _0x48b038 - _0x174aa3,
        _0x3b2b38 = parseInt(_0x5e7e41.dataset.baseComparePrice),
        _0x4e2460 = _0x3b2b38 * _0x30208a;
      this.offerPrices["offer_" + _0x1c22b4].price = _0x429664, this.offerPrices["offer_" + _0x1c22b4].compare_price = _0x4e2460;
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
  }
  updateInnerPrices() {
    this.labels.forEach(_0x38b537 => {
      const _0x4a84f4 = _0x38b537.dataset.input.replace("input_", ""),
        _0x3c90d3 = parseFloat(_0x38b537.dataset.quantity),
        _0x3ab844 = this.applySubTo(this.offerPrices["offer_" + _0x4a84f4].price),
        _0x3a71ea = this.offerPrices["offer_" + _0x4a84f4].compare_price;
      this.updateLabelPrices(_0x38b537, _0x3c90d3, _0x3ab844, _0x3a71ea);
    });
  }
  updateLabelPrices(_0x1841ac, _0x58180a, _0x436ed6, _0x14887b) {
    const _0x3ab4b2 = _0x14887b - _0x436ed6,
      _0x53743e = Math.round(_0x3ab4b2 / 100) * 100,
      _0x3d08af = _0x436ed6 / _0x58180a,
      _0x3abeed = _0x14887b / _0x58180a,
      _0x198056 = formatMoney(_0x436ed6, this.moneyFormat, true),
      _0x37aa66 = formatMoney(_0x14887b, this.moneyFormat, true),
      _0x4f9b78 = formatMoney(_0x3ab4b2, this.moneyFormat, true),
      _0x1320f0 = formatMoney(_0x53743e, this.moneyFormat, true),
      _0x3cde5a = formatMoney(_0x3d08af, this.moneyFormat, true),
      _0x1da996 = formatMoney(_0x3abeed, this.moneyFormat, true);
    _0x1841ac.querySelectorAll(".variant-price-update").forEach(_0x1a7d65 => {
      let _0x52aef6 = _0x1a7d65.dataset.text;
      _0x52aef6 = _0x52aef6.replace("[quantity]", _0x58180a), _0x52aef6 = _0x52aef6.replace("[price]", _0x198056), _0x52aef6 = _0x52aef6.replace("[compare_price]", _0x37aa66), _0x52aef6 = _0x52aef6.replace("[amount_saved]", _0x4f9b78), _0x52aef6 = _0x52aef6.replace("[amount_saved_rounded]", _0x1320f0), _0x52aef6 = _0x52aef6.replace("[price_each]", _0x3cde5a), _0x52aef6 = _0x52aef6.replace("[compare_price_each]", _0x1da996), _0x1a7d65.innerHTML = _0x52aef6;
    });
    const _0x292f23 = _0x1841ac.querySelector(".quantity-break__compare-price");
    _0x292f23 && (_0x14887b > _0x436ed6 ? _0x292f23.classList.remove("hidden") : _0x292f23.classList.add("hidden"));
  }
  updateDisplayedPdpPrices() {
    const _0x24ad08 = this.applySubTo(this.offerPrices["offer_" + this.selectedOffer].price),
      _0x5d6ff7 = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    updatePdpPrices(_0x24ad08, _0x5d6ff7, this.dataset.section, this.moneyFormat);
  }
  handleSelectChange(_0xdc1bba) {
    const _0x24f5f7 = _0xdc1bba.currentTarget,
      _0x3f3b3b = Array.from(_0x24f5f7.querySelectorAll("select"), _0x1b71b4 => _0x1b71b4.value);
    if (this.updateUnavailable) {
      const _0x5bdb65 = this.getVariantData().filter(_0x2e8731 => _0x24f5f7.querySelector(":checked").value === _0x2e8731.option1),
        _0x209cc6 = [..._0x24f5f7.querySelectorAll(".select--small")];
      updateVariantStatuses(_0x5bdb65, _0x209cc6, this.skipUnavailable);
    }
    const _0x4ceb19 = this.getVariantData().find(_0x1ea459 => {
      return !_0x1ea459.options.map((_0x40df25, _0xd5f332) => {
        return _0x3f3b3b[_0xd5f332] === _0x40df25;
      }).includes(false);
    });
    if (!_0x4ceb19) {
      if (this.skipNonExistent) findAvailableVariant(_0x24f5f7, _0x3f3b3b, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !_0x4ceb19.available) {
      if (findAvailableVariant(_0x24f5f7, _0x3f3b3b, false, true, true)) return;
    }
    _0x24f5f7.dataset.selectedId = _0x4ceb19.id;
    const _0x43476f = _0x24f5f7.dataset.selectIndex,
      _0x5c7420 = _0x24f5f7.closest(".quantity-break"),
      _0x231232 = _0x5c7420.dataset.input;
    this.selectedVariants[_0x231232][_0x43476f] = _0x4ceb19.id, this.formVariants = this.selectedVariants[_0x231232];
    if (!this.preventGalleryScroll) this.updateMedia(_0x4ceb19);
    const _0x1951b7 = _0x24f5f7.querySelector(".quantity-break__selector-item__image img");
    if (_0x1951b7) _0x1951b7.src = _0x4ceb19.featured_image.src;
    if (!this.updatePrices) return;
    var _0x48e7ce = 0,
      _0x4b2475 = 0;
    const _0x2eda2b = parseFloat(_0x5c7420.dataset.quantity),
      _0xd2a8be = parseFloat(_0x5c7420.dataset.percentageLeft),
      _0x4ceebb = parseFloat(_0x5c7420.dataset.fixedDiscount);
    var _0x39cdff = true;
    if (_0x5c7420.dataset.compareMode === "price") _0x39cdff = false;
    for (let _0x15acd6 = 0; _0x15acd6 < _0x2eda2b; _0x15acd6++) {
      const _0x22ef00 = parseInt(this.selectedVariants[_0x231232][_0x15acd6]),
        _0x461f90 = this.getVariantData().find(_0x5ec3b4 => parseInt(_0x5ec3b4.id) === _0x22ef00);
      if (!_0x461f90) return;
      _0x48e7ce += _0x461f90.price, _0x461f90.compare_at_price && _0x39cdff && _0x461f90.compare_at_price > _0x461f90.price ? _0x4b2475 += _0x461f90.compare_at_price : _0x4b2475 += _0x461f90.price;
    }
    _0x48e7ce = _0x48e7ce * _0xd2a8be - _0x4ceebb, this.offerPrices["offer_" + this.selectedOffer].price = _0x48e7ce, this.offerPrices["offer_" + this.selectedOffer].compare_price = _0x4b2475, _0x48e7ce = this.applySubTo(_0x48e7ce), this.updateLabelPrices(_0x5c7420, _0x2eda2b, _0x48e7ce, _0x4b2475);
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach(_0x5ed5a0 => {
      if (_0x5ed5a0.querySelector(".quantity-break__variants")) {
        let _0xd6e19b = [];
        _0x5ed5a0.querySelectorAll(".quantity-break__selector-item").forEach(_0x47b98a => {
          _0xd6e19b.push(_0x47b98a.dataset.selectedId);
        }), this.selectedVariants[_0x5ed5a0.dataset.input] = _0xd6e19b;
      }
    }), this.formVariants = [];
  }
  updateMedia(_0x317e07) {
    if (!_0x317e07) return;
    if (!_0x317e07.featured_media) return;
    const _0x300744 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x300744.forEach(_0xe97f42 => {
      if (_0xe97f42.setActiveMedia) _0xe97f42.setActiveMedia(this.dataset.section + "-" + _0x317e07.featured_media.id, true);
    });
  }
  handleChange(_0x21132d) {
    const _0x423041 = parseInt(_0x21132d.target.value);
    this.selectedQuantity = _0x423041, this.selectedOffer = parseInt(_0x21132d.target.dataset.input.replace("input_", ""));
    if (this.hasVariants) this.formVariants = this.selectedVariants[_0x21132d.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(_0x423041);
    this.quantityBreakUpsells.forEach(_0x2bab58 => {
      _0x2bab58.initUnlock();
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class ShrineSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.section, this.productForm = document.getElementById("product-form-" + this.sectionId), this.isCheckbox = this.dataset.isCheckbox === "true", this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]"), this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update"), this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]"), this.frequencySelect = this.querySelector(".subscription__select .select__select"), this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input"), this.subBoxTexts = this.querySelectorAll(".sub-price-update"), this.selectedPlanId = this.dataset.firstSellingPlanId, this.isSubSelected = this.dataset.preselected === "subscription", this.sellingPlanInput = null, this.subscriptionName = this.dataset.subscriptionName, this.basePrice = parseInt(this.dataset.basePrice), this.baseComparePrice = parseInt(this.dataset.baseComparePrice), this.updatePrices = this.dataset.updatePrices === "true", this.discountType = this.dataset.discountType, this.discountValue = parseInt(this.dataset.discountValue), this.displayedPrices = this.dataset.displayedPrices || "unit", this.moneyFormat = this.dataset.moneyFormat, this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantityBreaks && (this.quantityBreaks.updatePrices = true, this.quantityBreaks.updatePdpPrices = true);
    if (this.updatePrices) this.updateAllPrices();
    this.init(), this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices && (this.updatePricesFromQtyBreaks = true, this.renderSubTexts());
  }
  init() {
    this.createSellingPlanInput(), this.setupBoxClickListeners(), this.setupFrequencyListeners();
  }
  createSellingPlanInput() {
    this.sellingPlanInput = document.createElement("input"), this.sellingPlanInput.type = "hidden", this.sellingPlanInput.name = "selling_plan", this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
    if (this.productForm) this.productForm.appendChild(this.sellingPlanInput);
  }
  setupBoxClickListeners() {
    [this.oneTimeBox, this.subscriptionBox].forEach(_0x548880 => {
      if (!_0x548880) return;
      _0x548880.addEventListener("click", _0x3cc552 => {
        if (this.isCheckbox && _0x3cc552.target.closest(".subscription__frequency")) return;
        if (this.isCheckbox) {
          const _0x364e81 = _0x548880.classList.contains("subscription__box--selected");
          this.isSubSelected = !_0x364e81, _0x548880.classList.toggle("subscription__box--selected"), _0x548880.dataset.selected = !_0x364e81, this.sellingPlanInput.value = !_0x364e81 ? this.selectedPlanId : "";
        } else this.isSubSelected = _0x548880.dataset.type === "subscription", this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected"), this.subscriptionBox?.["classList"]["remove"]("subscription__box--selected"), this.oneTimeBox?.["setAttribute"]("data-selected", "false"), this.subscriptionBox?.["setAttribute"]("data-selected", "false"), _0x548880.classList.add("subscription__box--selected"), _0x548880.dataset.selected = "true", this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
        if (this.updatePrices) this.updateAllPrices();
      });
    });
  }
  updateAllPrices() {
    this.basePrice = parseInt(this.dataset.basePrice), this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) this.isSubSelected ? (this.quantityBreaks.subDiscountType = this.discountType, this.quantityBreaks.subDiscount = this.discountValue) : (this.quantityBreaks.subDiscountType = null, this.quantityBreaks.subDiscount = 0), this.quantityBreaks.updateDisplayedPdpPrices(), this.quantityBreaks.updateInnerPrices();else {
      let _0x3d109f = this.applySubTo(this.basePrice);
      updatePdpPrices(_0x3d109f, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    const _0x5c6d19 = document.querySelector("variant-selects[data-section=\"" + this.sectionId + "\"][data-has-quantity-breaks-picker=\"true\"]");
    _0x5c6d19 && _0x5c6d19.updateQuantityBreaksPickerPrices && _0x5c6d19.updateQuantityBreaksPickerPrices(this.isSubSelected ? this.discountType : null, this.isSubSelected ? this.discountValue : 0, this.moneyFormat), this.renderSubTexts();
  }
  applySubTo(_0x10364a, _0x5ef286 = false) {
    if (this.isSubSelected || _0x5ef286) {
      if (this.discountType === "fixed_amount") return Math.max(0, _0x10364a - this.discountValue);else {
        if (this.discountType === "percentage") return Math.round(_0x10364a * (100 - this.discountValue) / 100);else {
          if (this.discountType === "price") return this.discountValue;
        }
      }
    }
    return _0x10364a;
  }
  setupFrequencyListeners() {
    this.frequencyRadios.forEach(_0x598382 => {
      _0x598382.addEventListener("change", _0x268d8a => {
        this.applyFrequencyNode(_0x268d8a.currentTarget);
      });
    }), this.frequencySelect && this.frequencySelect.addEventListener("change", () => {
      const _0x34028b = this.frequencySelect.selectedOptions?.[0];
      if (_0x34028b) this.applyFrequencyNode(_0x34028b);
    });
  }
  applyFrequencyNode(_0x26d39f) {
    this.selectedPlanId = _0x26d39f.dataset.sellingPlanId, this.discountType = _0x26d39f.dataset.discountType || this.discountType, this.discountValue = _0x26d39f.dataset.discountValue ? parseInt(_0x26d39f.dataset.discountValue, 10) : this.discountValue;
    this.subscriptionBox?.["classList"]["contains"]("subscription__box--selected") && (this.sellingPlanInput.value = this.selectedPlanId || "");
    if (this.updatePrices) this.updateAllPrices();
  }
  computeSubPrices(_0x1da79d = true) {
    let _0x191ebb = this.basePrice,
      _0x3d13af = this.baseComparePrice;
    this.quantityBreaks && this.displayedPrices !== "unit" && (_0x191ebb = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price, _0x3d13af = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].compare_price, this.displayedPrices == "unit_with_discount" && (_0x191ebb = _0x191ebb / this.quantityBreaks.selectedQuantity, _0x3d13af = _0x3d13af / this.quantityBreaks.selectedQuantity));
    if (_0x1da79d) _0x191ebb = this.applySubTo(_0x191ebb, true);
    let _0x5328d1 = this.subscriptionName;
    const _0x874d4a = Math.max(0, _0x3d13af - _0x191ebb),
      _0x145b6c = Math.round(_0x874d4a / 100) * 100,
      _0x1118a2 = _0x3d13af > 0 ? Math.round(_0x874d4a * 100 / _0x3d13af) : 0;
    return {
      "price": _0x191ebb,
      "comparePrice": _0x3d13af,
      "amount_saved": _0x874d4a,
      "amount_saved_rounded": _0x145b6c,
      "percentage_saved": _0x1118a2,
      "subscription_name": _0x5328d1
    };
  }
  renderSubTexts() {
    if (this.subBoxTexts.length > 0) {
      const {
        price: _0x52e670,
        compare_price: _0x35125f,
        amount_saved: _0x174af1,
        amount_saved_rounded: _0x316cee,
        percentage_saved: _0x37479e,
        subscription_name: _0x37c790
      } = this.computeSubPrices();
      this.updatePriceTexts(this.subBoxTexts, _0x52e670, _0x35125f, _0x174af1, _0x316cee, _0x37479e, _0x37c790);
    }
    if (this.updatePricesFromQtyBreaks) this.renderOneTimeTexts();
  }
  renderOneTimeTexts() {
    if (this.oneTimeBoxTexts.length > 0) {
      const {
        price: _0x11de7d,
        compare_price: _0xbcbece,
        amount_saved: _0x8e98f6,
        amount_saved_rounded: _0x582d8f,
        percentage_saved: _0x498f76,
        subscription_name: _0x1e73cc
      } = this.computeSubPrices(false);
      this.updatePriceTexts(this.oneTimeBoxTexts, _0x11de7d, _0xbcbece, _0x8e98f6, _0x582d8f, _0x498f76, _0x1e73cc);
    }
  }
  updatePriceTexts(_0x164af9, _0x572731, _0x135d2a, _0x1ffbb9, _0x519633, _0x595637, _0x2719a2) {
    const _0x361394 = _0x33b2cc => formatMoney(_0x33b2cc, this.moneyFormat, true);
    _0x164af9.forEach(_0x5e9b20 => {
      let _0x378fd9 = _0x5e9b20.dataset.text || "";
      _0x378fd9 = _0x378fd9.replaceAll("[price]", _0x361394(_0x572731)).replaceAll("[compare_price]", _0x361394(_0x135d2a)).replaceAll("[amount_saved]", _0x361394(_0x1ffbb9)).replaceAll("[amount_saved_rounded]", _0x361394(_0x519633)).replaceAll("[percentage_saved]", String(_0x595637) + "%").replaceAll("[subscription_name]", _0x2719a2 || ""), _0x5e9b20.innerHTML = _0x378fd9, _0x5e9b20.classList.contains("subscription__compare-price") && _0x5e9b20.classList.toggle("hidden", !(_0x135d2a > _0x572731));
    });
  }
  hydrateFromExternalHTML(_0x25949c) {
    const _0x20bbd3 = _0x10cec0 => {
        const _0x131aea = _0x10cec0.querySelector(".subscription__select .select__select"),
          _0x537639 = _0x10cec0.querySelectorAll(".subscription__frequency-input");
        if (_0x131aea) return {
          "type": "select",
          "count": _0x131aea.options.length,
          "index": _0x131aea.selectedIndex >= 0 ? _0x131aea.selectedIndex : 0
        };
        if (_0x537639.length) {
          const _0x31911a = Array.from(_0x537639).findIndex(_0x59e184 => _0x59e184.checked);
          return {
            "type": "radio",
            "count": _0x537639.length,
            "index": _0x31911a >= 0 ? _0x31911a : 0
          };
        }
        return {
          "type": "none",
          "count": 0,
          "index": 0
        };
      },
      _0x13d281 = _0x20bbd3(this),
      _0xc0358b = this.isSubSelected;
    this.dataset.firstSellingPlanId = _0x25949c.dataset.firstSellingPlanId ?? "", this.dataset.subscriptionName = _0x25949c.dataset.subscriptionName ?? "", this.dataset.discountType = _0x25949c.dataset.discountType ?? "", this.dataset.discountValue = _0x25949c.dataset.discountValue ?? "0";
    const _0x252c8a = _0x25949c.querySelector(".subscription__wrapper"),
      _0xc6935c = this.querySelector(".subscription__wrapper");
    if (_0x252c8a && _0xc6935c) _0xc6935c.replaceWith(_0x252c8a);
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]"), this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update"), this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]"), this.subBoxTexts = this.querySelectorAll(".sub-price-update"), this.frequencySelect = this.querySelector(".subscription__select .select__select"), this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    const _0x3c5a06 = _0x20bbd3(this);
    let _0x2cb791 = 0;
    _0x13d281.type !== "none" && _0x3c5a06.type !== "none" && _0x13d281.count === _0x3c5a06.count && (_0x2cb791 = Math.max(0, Math.min(_0x13d281.index, _0x3c5a06.count - 1)));
    if (_0x3c5a06.type === "select" && this.frequencySelect) this.frequencySelect.selectedIndex = _0x2cb791;else _0x3c5a06.type === "radio" && this.frequencyRadios.length && this.frequencyRadios.forEach((_0x2e90bd, _0x1ed40c) => {
      _0x2e90bd.checked = _0x1ed40c === _0x2cb791;
    });
    let _0x3eba71 = null;
    if (this.frequencySelect) _0x3eba71 = this.frequencySelect.selectedOptions?.[0] || this.frequencySelect.options?.[0] || null;else this.frequencyRadios.length && (_0x3eba71 = Array.from(this.frequencyRadios).find(_0x40db8b => _0x40db8b.checked) || this.frequencyRadios[0]);
    this.selectedPlanId = _0x3eba71?.["dataset"]["sellingPlanId"] || this.dataset.firstSellingPlanId || "", _0x3eba71 ? this.applyFrequencyNode(_0x3eba71) : (this.selectedPlanId = this.dataset.firstSellingPlanId || "", this.discountType = this.dataset.discountType || "", this.discountValue = parseInt(this.dataset.discountValue || "0", 10)), _0xc0358b && this.subscriptionBox ? (this.subscriptionBox.classList.add("subscription__box--selected"), this.subscriptionBox.setAttribute("data-selected", "true"), this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected"), this.oneTimeBox?.["setAttribute"]("data-selected", "false"), this.isSubSelected = true, this.sellingPlanInput.value = this.selectedPlanId || "") : (this.subscriptionBox?.["classList"]["remove"]("subscription__box--selected"), this.subscriptionBox?.["setAttribute"]("data-selected", "false"), this.oneTimeBox && (this.oneTimeBox.classList.add("subscription__box--selected"), this.oneTimeBox.setAttribute("data-selected", "true")), this.isSubSelected = false, this.sellingPlanInput.value = ""), this.setupBoxClickListeners(), this.setupFrequencyListeners(), this.updatePrices ? this.updateAllPrices() : this.renderSubTexts();
  }
}
customElements.define("shrine-subscription-widget", ShrineSubscriptionWidget);
function updatePdpPrices(_0x5e82e8, _0x40aed9, _0x46f55e, _0x55237e) {
  const _0x81adca = formatMoney(_0x5e82e8, _0x55237e),
    _0x4a9c3d = formatMoney(_0x40aed9, _0x55237e),
    _0x137421 = _0x40aed9 > _0x5e82e8,
    _0x3c5c87 = document.querySelectorAll(".price-" + _0x46f55e);
  _0x3c5c87.forEach(_0x39987f => {
    _0x39987f.classList.toggle("price--on-sale", _0x137421), _0x39987f.querySelector(".price__regular .price-item--regular").innerHTML = _0x81adca, _0x39987f.querySelector(".price__sale .price-item--sale").innerHTML = _0x81adca;
    if (_0x137421) {
      const _0x36f983 = _0x39987f.querySelector(".price__sale .price-item--regular");
      if (_0x36f983) _0x36f983.innerHTML = _0x4a9c3d;
      const _0x4fc675 = _0x39987f.querySelector(".badge__percentage-saved");
      if (_0x4fc675) {
        const _0x18f947 = Math.round((_0x40aed9 - _0x5e82e8) * 100 / _0x40aed9);
        _0x4fc675.innerHTML = _0x18f947;
      }
      const _0x5e14e9 = _0x39987f.querySelector(".badge__money-saved");
      if (_0x5e14e9) {
        const _0x2519be = _0x40aed9 - _0x5e82e8,
          _0x76c8e7 = formatMoney(_0x2519be, _0x55237e, true);
        _0x5e14e9.innerHTML = _0x76c8e7;
      }
    }
  });
  const _0x341f3b = document.querySelectorAll(".main-atc-price-span-" + _0x46f55e);
  _0x341f3b.forEach(_0x522a17 => {
    _0x522a17.innerHTML = _0x81adca;
  });
}
function updateVariantStatuses(_0x3933b2, _0x25dacc, _0x584f13 = false) {
  _0x25dacc.forEach((_0x2ec3fe, _0x12d3a9) => {
    if (_0x12d3a9 === 0) return;
    const _0x386fbb = [..._0x2ec3fe.querySelectorAll("option")],
      _0x55e3f3 = _0x25dacc[_0x12d3a9 - 1].querySelector(":checked").value,
      _0x278641 = _0x3933b2.filter(_0x1c22df => _0x1c22df.available && _0x1c22df["option" + _0x12d3a9] === _0x55e3f3).map(_0x485a58 => _0x485a58["option" + (_0x12d3a9 + 1)]),
      _0x205d8a = _0x3933b2.filter(_0x5df884 => _0x5df884["option" + _0x12d3a9] === _0x55e3f3).map(_0x59a512 => _0x59a512["option" + (_0x12d3a9 + 1)]);
    _0x386fbb.forEach(_0x3f2fbc => {
      _0x3f2fbc.classList.remove("unavailable", "non-existent"), _0x3f2fbc.removeAttribute("disabled"), _0x3f2fbc.removeAttribute("hidden"), _0x205d8a.includes(_0x3f2fbc.getAttribute("value")) ? _0x278641.includes(_0x3f2fbc.getAttribute("value")) ? _0x3f2fbc.innerText = _0x3f2fbc.getAttribute("value") : (_0x3f2fbc.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x3f2fbc.getAttribute("value")), _0x3f2fbc.classList.add("unavailable"), _0x584f13 && (_0x3f2fbc.setAttribute("disabled", ""), _0x3f2fbc.setAttribute("hidden", ""))) : (_0x3f2fbc.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x3f2fbc.getAttribute("value")), _0x3f2fbc.classList.add("non-existent"), _0x3f2fbc.setAttribute("disabled", ""), _0x3f2fbc.setAttribute("hidden", ""));
    });
  });
}
function findAvailableVariant(_0x2e271e, _0x1cae4c, _0x38c77f = true, _0x5b3dfb = false, _0x3f4dfa = false) {
  for (let _0x3b7960 = _0x1cae4c.length - 1; _0x3b7960 >= 0; _0x3b7960--) {
    const _0xb49793 = _0x38c77f ? _0x2e271e.querySelector(".product-form__input:nth-child(" + (_0x3b7960 + 1) + ")") : _0x2e271e.querySelectorAll(".select")[_0x3b7960],
      _0x3bf1df = _0x38c77f ? _0xb49793.querySelector(".product-form__input__type").dataset.type : "dropdown",
      _0x1af836 = _0x3bf1df === "dropdown" ? _0xb49793.querySelectorAll("option") : _0xb49793.querySelectorAll("input[type=\"radio\"]");
    let _0x3a8f98 = Array.from(_0x1af836).findIndex(_0x41f080 => _0x41f080.value === _0x1cae4c[_0x3b7960]),
      _0x405604 = false;
    while (_0x3a8f98 < _0x1af836.length - 1) {
      _0x3a8f98++;
      const _0x157856 = _0x1af836[_0x3a8f98];
      if ((!_0x5b3dfb || !_0x157856.classList.contains("non-existent")) && (!_0x3f4dfa || !_0x157856.classList.contains("unavailable"))) {
        _0x1cae4c[_0x3b7960] = _0x157856.value, _0x405604 = true;
        break;
      }
    }
    if (!_0x405604) {
      _0x3a8f98 = Array.from(_0x1af836).findIndex(_0x2d50d4 => _0x2d50d4.value === _0x1cae4c[_0x3b7960]);
      while (_0x3a8f98 > 0) {
        _0x3a8f98--;
        const _0x4bb80d = _0x1af836[_0x3a8f98];
        if ((!_0x5b3dfb || !_0x4bb80d.classList.contains("non-existent")) && (!_0x3f4dfa || !_0x4bb80d.classList.contains("unavailable"))) {
          _0x1cae4c[_0x3b7960] = _0x4bb80d.value, _0x405604 = true;
          break;
        }
      }
    }
    if (_0x405604) return _0x3bf1df === "dropdown" ? _0xb49793.querySelector(".select__select").value = _0x1cae4c[_0x3b7960] : _0xb49793.querySelector("input[type=\"radio\"][value=\"" + _0x1cae4c[_0x3b7960] + "\"]").checked = true, _0x2e271e.dispatchEvent(new Event("change")), true;
  }
  return false;
}
function updateGiftGoalInStorage({
  giftHandle: _0x465789,
  giftVariantId: _0x1b388b,
  unlockType: _0x2e5566,
  unlockRequirement: _0x10af8f,
  unlockTarget: _0x2a22e0
}) {
  const _0x2c927b = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
  if (!_0x465789 || !_0x1b388b || !_0x10af8f || !_0x2e5566) return;
  const _0x5b0c5d = {
    "type": _0x2e5566,
    "gift_handle": _0x465789,
    "gift_variant_id": Number(_0x1b388b),
    "unlock_product_handle": _0x2a22e0 || null
  };
  _0x2e5566 === "product_variant" ? Array.isArray(_0x10af8f) ? _0x5b0c5d.valid_variants = _0x10af8f.map(_0x4de388 => String(_0x4de388).toLowerCase().trim()) : _0x5b0c5d.valid_variants = [String(_0x10af8f).toLowerCase().trim()] : _0x5b0c5d.required_quantity = Number(_0x10af8f), _0x2c927b[_0x465789] = _0x5b0c5d, localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(_0x2c927b));
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super(), this.gifts = this.querySelectorAll(".quantity-gift"), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section), this.unlockedItems = [], this.mainProduct = this.dataset.mainProduct, this.cartItems = document.querySelector("cart-drawer-items"), this.unlockBy = this.dataset.unlockBy === "variant" ? "variant" : "quantity", this.initUnlock(), this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage && this.unlockBy !== "variant") this.storeLocalStorageData();
  }
  connectedCallback() {
    if (this.unlockBy !== "variant") return;
    this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({
      data: _0x4de30f
    }) => {
      if (!_0x4de30f || _0x4de30f.sectionId !== this.dataset.section) return;
      this.unlockGiftsByVariant(_0x4de30f.variant, false);
    });
  }
  disconnectedCallback() {
    this._variantUnsub && (this._variantUnsub(), this._variantUnsub = undefined);
  }
  storeLocalStorageData() {
    this.gifts.forEach(_0x5a4a68 => {
      updateGiftGoalInStorage({
        "giftHandle": _0x5a4a68.dataset.handle,
        "giftVariantId": _0x5a4a68.dataset.product,
        "unlockType": "product_quantity",
        "unlockRequirement": _0x5a4a68.dataset.quantity,
        "unlockTarget": this.mainProduct
      });
    });
  }
  initUnlock() {
    if (this.unlockBy === "variant") {
      const _0x402ba2 = this._readCurrentVariant();
      this.unlockGiftsByVariant(_0x402ba2, true);
      return;
    }
    let _0x3e0e49 = 1;
    const _0x11322f = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
    if (_0x11322f && _0x11322f.length) {
      _0x3e0e49 = 0;
      for (let _0xab78ca = 0; _0xab78ca < _0x11322f.length; _0xab78ca++) {
        _0x3e0e49 += parseInt(_0x11322f[_0xab78ca].dataset.quantity);
      }
    } else {
      if (this.quantityBreaks) _0x3e0e49 = parseInt(this.quantityBreaks.selectedQuantity);else {
        if (this.quantitySelector) {
          const _0x5ca10b = this.quantitySelector.querySelector("input[name=\"quantity\"]");
          _0x3e0e49 = parseInt(_0x5ca10b.value);
        }
      }
    }
    this.unlockGifts(_0x3e0e49, true);
  }
  unlockGifts(_0x4907d5, _0x24e754 = false) {
    if (this.unlockBy === "variant") return;
    this.unlockedItems = [], this.gifts.forEach(_0x276fba => {
      if (parseInt(_0x276fba.dataset.quantity) <= _0x4907d5) {
        _0x276fba.classList.add("quantity-gift--unlocked"), _0x276fba.dataset.unlocked = "true";
        const _0x18b5ad = document.querySelector(".cart-item--product-" + _0x276fba.dataset.handle);
        if (_0x276fba.dataset.product && !_0x18b5ad) this.unlockedItems.unshift(_0x276fba.dataset.product);
      } else _0x276fba.classList.remove("quantity-gift--unlocked"), _0x276fba.dataset.unlocked = "false";
    });
    if (this.mainProduct && _0x24e754) this.addRemoveProducts();
  }
  _readCurrentVariant() {
    const _0x588220 = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
    if (!_0x588220) return null;
    if (_0x588220.currentVariant) return _0x588220.currentVariant;
    const _0x26c027 = [];
    _0x588220.querySelectorAll(".product-form__input").forEach(_0x6f02bd => {
      const _0xf336e = _0x6f02bd.querySelector(".product-form__input__type"),
        _0x53c36e = _0xf336e ? _0xf336e.dataset.type : null;
      let _0x4b5617;
      if (_0x53c36e === "dropdown" || _0x53c36e === "dropdwon") {
        const _0x461039 = _0x6f02bd.querySelector(".select__select");
        _0x4b5617 = _0x461039 ? _0x461039.value : undefined;
      } else {
        const _0x1a3567 = _0x6f02bd.querySelector("input[type=\"radio\"]:checked");
        _0x4b5617 = _0x1a3567 ? _0x1a3567.value : undefined;
      }
      if (_0x4b5617 !== undefined) _0x26c027.push(_0x4b5617);
    });
    try {
      const _0x5b86be = _0x588220.querySelector("[type=\"application/json\"]");
      if (!_0x5b86be) return null;
      const _0x5a83d6 = JSON.parse(_0x5b86be.textContent);
      return _0x5a83d6.find(_0x21dfff => Array.isArray(_0x21dfff.options) && _0x21dfff.options.length === _0x26c027.length && _0x21dfff.options.every((_0x2ff6ec, _0x27ac93) => _0x2ff6ec === _0x26c027[_0x27ac93])) || null;
    } catch (_0x302d9a) {
      return null;
    }
  }
  _getOptionOrders() {
    const _0x2fbde4 = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
    if (!_0x2fbde4) return null;
    try {
      const _0x4ce1c1 = _0x2fbde4.querySelector("[type=\"application/json\"]");
      if (!_0x4ce1c1) return null;
      const _0x58993e = JSON.parse(_0x4ce1c1.textContent),
        _0x4cc73d = {
          "option1": [],
          "option2": [],
          "option3": []
        };
      return _0x58993e.forEach(_0x1ca451 => {
        ["option1", "option2", "option3"].forEach(_0xb25b0a => {
          const _0x3fc6df = _0x1ca451[_0xb25b0a];
          if (_0x3fc6df !== null && _0x3fc6df !== undefined) {
            const _0x29fc69 = String(_0x3fc6df).toLowerCase().trim();
            !_0x4cc73d[_0xb25b0a].includes(_0x29fc69) && _0x4cc73d[_0xb25b0a].push(_0x29fc69);
          }
        });
      }), _0x4cc73d;
    } catch (_0x2692e6) {
      return null;
    }
  }
  unlockGiftsByVariant(_0x36e121, _0x1c7a20 = false) {
    this.unlockedItems = [];
    if (!_0x36e121) {
      this.gifts.forEach(_0x34b058 => {
        _0x34b058.classList.remove("quantity-gift--unlocked"), _0x34b058.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
          "gift_handle": _0x34b058.dataset.handle
        });
      });
      if (this.mainProduct && _0x1c7a20) this.addRemoveProducts();
      return;
    }
    const _0x40131e = this._getOptionOrders(),
      _0x52cf99 = {
        "option1": _0x36e121.option1 ? String(_0x36e121.option1).toLowerCase().trim() : null,
        "option2": _0x36e121.option2 ? String(_0x36e121.option2).toLowerCase().trim() : null,
        "option3": _0x36e121.option3 ? String(_0x36e121.option3).toLowerCase().trim() : null
      };
    this.gifts.forEach(_0x598de0 => {
      const _0x434bd4 = (_0x598de0.dataset.variant || "").toLowerCase().trim();
      if (!_0x434bd4.length) {
        _0x598de0.classList.remove("quantity-gift--unlocked"), _0x598de0.dataset.unlocked = "false";
        this.saveLocalStorage && removeLocalStorageGift({
          "gift_handle": _0x598de0.dataset.handle
        });
        return;
      }
      let _0x146229 = false,
        _0x2b8179 = [];
      if (_0x40131e) for (const _0x193e78 of ["option1", "option2", "option3"]) {
        const _0x26d54a = _0x40131e[_0x193e78],
          _0x4f7fcb = _0x26d54a.indexOf(_0x434bd4);
        if (_0x4f7fcb === -1) continue;
        const _0x244eef = _0x52cf99[_0x193e78],
          _0x53ebfe = _0x244eef ? _0x26d54a.indexOf(_0x244eef) : -1;
        _0x53ebfe >= _0x4f7fcb && (_0x146229 = true, _0x2b8179 = _0x26d54a.slice(_0x4f7fcb));
        break;
      }
      if (!_0x40131e) {
        const _0x327d45 = [_0x36e121.title, _0x36e121.option1, _0x36e121.option2, _0x36e121.option3, ...(Array.isArray(_0x36e121.options) ? _0x36e121.options : [])].filter(_0x46ab8e => _0x46ab8e !== undefined && _0x46ab8e !== null).map(_0x54e619 => String(_0x54e619).toLowerCase().trim());
        _0x146229 = _0x327d45.includes(_0x434bd4), _0x2b8179 = [_0x434bd4];
      }
      if (_0x146229) {
        _0x598de0.classList.add("quantity-gift--unlocked"), _0x598de0.dataset.unlocked = "true";
        const _0x163489 = document.querySelector(".cart-item--product-" + _0x598de0.dataset.handle);
        if (_0x598de0.dataset.product && !_0x163489) this.unlockedItems.unshift(_0x598de0.dataset.product);
        this.saveLocalStorage && updateGiftGoalInStorage({
          "giftHandle": _0x598de0.dataset.handle,
          "giftVariantId": _0x598de0.dataset.product,
          "unlockType": "product_variant",
          "unlockRequirement": _0x2b8179,
          "unlockTarget": this.mainProduct
        });
      } else _0x598de0.classList.remove("quantity-gift--unlocked"), _0x598de0.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
        "gift_handle": _0x598de0.dataset.handle
      });
    });
    if (this.mainProduct && _0x1c7a20) this.addRemoveProducts();
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const _0x2dcf1a = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach(_0x20fb53 => {
      _0x2dcf1a.length ? _0x20fb53.dataset.unlocked === "true" && _0x20fb53.dataset.product ? this.addToCart(_0x20fb53) : this.removeFromCart(_0x20fb53) : this.removeFromCart(_0x20fb53);
    });
  }
  addToCart(_0x2ab8c7) {
    const _0x2f1aeb = document.querySelector(".cart-item--product-" + _0x2ab8c7.dataset.handle);
    if (_0x2f1aeb) return;
    const _0x29b849 = _0x2ab8c7.querySelector("product-form");
    if (_0x29b849 && _0x29b849.handleSubmit) _0x29b849.handleSubmit();
  }
  removeFromCart(_0x4cae51) {
    const _0x4e9284 = document.querySelector(".cart-item--product-" + _0x4cae51.dataset.handle);
    if (!_0x4e9284 || !this.cartItems) return;
    this.cartItems.updateQuantity(_0x4e9284.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super(), this.offerIndex = this.dataset.offer, this.upsells = this.querySelectorAll(".quantity-break__upsell"), this.boundToggleHandler = this.handleToggle.bind(this), this.upsells.forEach(_0xf3ff35 => {
      _0xf3ff35.dataset.toggle === "true" && _0xf3ff35.addEventListener("click", this.boundToggleHandler);
    }), this.initUnlock();
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.upsells) return;
    this.upsells.forEach(_0x3cfccc => {
      if (_0x3cfccc.dataset.type !== "gift") return;
      updateGiftGoalInStorage({
        "giftHandle": _0x3cfccc.dataset.handle,
        "giftVariantId": _0x3cfccc.dataset.product,
        "unlockType": "product_quantity",
        "unlockRequirement": _0x3cfccc.dataset.minQuantity,
        "unlockTarget": this.dataset.mainProduct
      });
    });
  }
  disconnectedCallback() {
    this.upsells.forEach(_0x3c4b4a => {
      _0x3c4b4a.dataset.toggle === "true" && _0x3c4b4a.removeEventListener("click", this.boundToggleHandler);
    });
  }
  unlockGifts(_0x384d53, _0x59afc4 = false) {
    this.unlockedItems = [];
    if (!this.upsells) return;
    this.upsells.forEach(_0x2bfbd5 => {
      const _0x44d296 = parseInt(_0x2bfbd5.dataset.minQuantity || 0),
        _0x8b912a = _0x384d53 >= _0x44d296,
        _0x5a34e5 = _0x2bfbd5.dataset.selected === "true",
        _0x2f32a4 = _0x8b912a && _0x5a34e5;
      _0x2bfbd5.dataset.unlocked = _0x2f32a4.toString(), _0x2bfbd5.classList.toggle("quantity-gift--unlocked", _0x2f32a4);
      const _0x57dede = document.querySelector(".cart-item--product-" + _0x2bfbd5.dataset.handle);
      if (_0x2f32a4 && _0x2bfbd5.dataset.product && !_0x57dede) {
        const _0x1958be = _0x2bfbd5.dataset.toggle === "true",
          _0x4871f8 = _0x2bfbd5.dataset.selected === "true";
        (!_0x1958be || _0x1958be && _0x4871f8) && this.unlockedItems.unshift(_0x2bfbd5.dataset.product);
      }
    });
    if (this.mainProduct && _0x59afc4) {
      if (this.dataset.lastOffer === this.dataset.offer) this.addRemoveProducts();
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const _0x5ec82a = document.querySelectorAll(".cart-item--product-" + this.mainProduct),
      _0x3a31c2 = [],
      _0x12570f = [];
    this.upsells.forEach(_0x62ca54 => {
      const _0x585156 = document.querySelector(".cart-item--product-" + _0x62ca54.dataset.handle),
        _0x59c338 = _0x62ca54.dataset.unlocked === "true";
      if (_0x5ec82a.length) {
        if (_0x59c338 && !_0x585156) _0x3a31c2.push(_0x62ca54);else !_0x59c338 && _0x585156 && _0x12570f.push(_0x62ca54);
      } else _0x585156 && _0x12570f.push(_0x62ca54);
    });
    if (_0x12570f.length) this.removeFromCart(_0x12570f[0]);else _0x3a31c2.length && this.addToCart(_0x3a31c2[0]);
  }
  handleToggle(_0x431939) {
    const _0x331258 = _0x431939.currentTarget,
      _0x4bb696 = _0x331258.dataset.selected === "true";
    _0x331258.dataset.selected = (!_0x4bb696).toString(), this.syncUpsellAcrossOffers(_0x331258.dataset.handle, !_0x4bb696), this.syncCart(_0x331258.dataset.handle, !_0x4bb696, _0x331258);
  }
  syncUpsellAcrossOffers(_0x2e67d2, _0x31852a) {
    const _0x10689a = document.querySelectorAll("quantity-break-upsells");
    _0x10689a.forEach(_0x3a6936 => {
      _0x3a6936.querySelectorAll(".quantity-break__upsell[data-handle=\"" + _0x2e67d2 + "\"]").forEach(_0x3c28f7 => {
        _0x3c28f7.dataset.selected = _0x31852a.toString();
      });
    });
  }
  syncCart(_0x1bfb54, _0x4638ef, _0x30f3b0) {
    const _0x5643d5 = document.querySelector(".cart-item--product-" + _0x1bfb54);
    if (!this.cartItems) return;
    if (_0x4638ef && !_0x5643d5) this.addToCart(_0x30f3b0);else !_0x4638ef && _0x5643d5 && this.removeFromCart(_0x30f3b0);
  }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(), this.image = this.querySelector(".upsell__image__img"), this.toggleBtn = this.querySelector(".upsell-toggle-btn"), this.variantSelects = this.querySelector(".upsell__variant-picker"), this.variantSelectElements = this.querySelectorAll(".select__select"), this.jsonData = this.querySelector("[type=\"application/json\"]"), this.productForm = this.querySelector("product-form");
    if (this.productForm) this.idInput = this.productForm.querySelector("[name=\"id\"]");
    this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price), this.comparePrice = parseInt(this.dataset.comparePrice), this.priceSpan = this.querySelector(".upsell__price .regular-price"), this.comparePriceSpan = this.querySelector(".upsell__price .compare-price"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat, this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    if (this.variantSelects) this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  handleToggle(_0x2f9ab3) {
    if (_0x2f9ab3.target.nodeName.toLowerCase() === "select" || _0x2f9ab3.target.nodeName.toLowerCase() === "option") return;
    this.dataset.selected === "true" ? this.dataset.selected = "false" : this.dataset.selected = "true";
  }
  handleSelectChange(_0x3b3a99) {
    const _0x20a27c = _0x3b3a99.currentTarget,
      _0x430a07 = Array.from(_0x20a27c.querySelectorAll("select"), _0x36604d => _0x36604d.value),
      _0x1825d3 = this.getVariantData().find(_0x25980c => {
        return !_0x25980c.options.map((_0x3bf5b3, _0x103a37) => {
          return _0x430a07[_0x103a37] === _0x3bf5b3;
        }).includes(false);
      }),
      _0x1dc4f3 = this.getVariantData().filter(_0x49c7d2 => _0x20a27c.querySelector(":checked").value === _0x49c7d2.option1),
      _0x5c7e2d = [..._0x20a27c.querySelectorAll("select")];
    updateVariantStatuses(_0x1dc4f3, _0x5c7e2d, this.skipUnavailable);
    if (!_0x1825d3) {
      if (this.skipNonExistent) findAvailableVariant(_0x20a27c, _0x430a07, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !_0x1825d3.available) {
      if (findAvailableVariant(_0x20a27c, _0x430a07, false, true, true)) return;
    }
    this.updatePrices && (this.price = _0x1825d3.price * this.percentageLeft - this.fixedDiscount, this.comparePrice = _0x1825d3.price, _0x1825d3.compare_at_price && _0x1825d3.compare_at_price > _0x1825d3.price && (this.comparePrice = _0x1825d3.compare_at_price), displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat));
    if (this.image && _0x1825d3.featured_image) this.image.src = _0x1825d3.featured_image.src;
    this.updateId(_0x1825d3.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) this.mainOfferContainer.updateTotalPrices();
  }
  updateId(_0x5b87e6) {
    this.dataset.id = _0x5b87e6;
    if (this.idInput) this.idInput.value = _0x5b87e6;
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector("cart-drawer-items") : null, this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(_0x588a30) {
    if (_0x588a30.target.nodeName.toLowerCase() === "select" || _0x588a30.target.nodeName.toLowerCase() === "option") return;
    this.dataset.selected === "true" ? (this.dataset.selected = "false", this.removeFromCart()) : (this.dataset.selected = "true", this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty") ? this.addToCart() : this.removeFromCart();
  }
  addToCart() {
    const _0xbf0142 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (_0xbf0142) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach(_0x461050 => {
      _0x461050.setAttribute("disabled", "");
    }), this.productForm.handleSubmit();
  }
  removeFromCart() {
    const _0x5cd8b9 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!_0x5cd8b9 || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach(_0x31de88 => {
      _0x31de88.setAttribute("disabled", "");
    }), this.cartItems.updateQuantity(_0x5cd8b9.dataset.index, 0);
  }
  updateId(_0x53d350) {
    this.dataset.id = _0x53d350, this.idInput.value = _0x53d350;
    if (this.classicAddButton) return;
    if (this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const _0x199635 = _0x12fcb5 => {
        _0x12fcb5.detail.handle === "handle" && (this.addToCart(), document.removeEventListener("cartQuantityUpdated", _0x199635));
      };
      document.addEventListener("cartQuantityUpdated", _0x199635);
    }
  }
  getUpdateRequired() {
    const _0x28e5e = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let _0x55a88a = false;
    if (_0x28e5e && this.dataset.selected === "false") _0x55a88a = true;else !_0x28e5e && this.dataset.selected === "true" && (_0x55a88a = true);
    return _0x55a88a;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_0x117534, _0x132deb, _0x1339ed, _0x51983c, _0x238b88) {
  if (!_0x238b88) return;
  if (_0x117534 && _0x1339ed) {
    var _0x3cface = formatMoney(_0x117534, _0x238b88);
    _0x1339ed.innerHTML = _0x3cface;
  }
  if (_0x132deb && _0x51983c) {
    var _0x48c830 = formatMoney(_0x132deb, _0x238b88);
    _0x51983c.innerHTML = _0x48c830, _0x132deb > _0x117534 ? _0x51983c.classList.remove("hidden") : _0x51983c.classList.add("hidden");
  }
}
function formatMoney(_0x1b2b98, _0x34ed8a, _0x14ba77 = false) {
  typeof _0x1b2b98 == "string" && (_0x1b2b98 = _0x1b2b98.replace(".", ""));
  var _0x431dfb = "",
    _0x41b2f3 = /\{\{\s*(\w+)\s*\}\}/,
    _0x2d60f2 = _0x34ed8a;
  function _0x1196c1(_0x2b98e1, _0x241a1d) {
    return typeof _0x2b98e1 == "undefined" ? _0x241a1d : _0x2b98e1;
  }
  function _0x595a77(_0x1e6433, _0x491a57, _0xbc7318, _0x591def) {
    _0x491a57 = _0x1196c1(_0x491a57, 2), _0xbc7318 = _0x1196c1(_0xbc7318, ","), _0x591def = _0x1196c1(_0x591def, ".");
    if (isNaN(_0x1e6433) || _0x1e6433 == null) return 0;
    _0x1e6433 = (_0x1e6433 / 100).toFixed(_0x491a57);
    var _0x395070 = _0x1e6433.split("."),
      _0x2ee8d5 = _0x395070[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0xbc7318),
      _0x4e7a7b = _0x395070[1] ? _0x591def + _0x395070[1] : "";
    return _0x14ba77 && _0x4e7a7b === _0x591def + "00" && (_0x4e7a7b = ""), _0x2ee8d5 + _0x4e7a7b;
  }
  switch (_0x2d60f2.match(_0x41b2f3)[1]) {
    case "amount":
      _0x431dfb = _0x595a77(_0x1b2b98, 2);
      break;
    case "amount_no_decimals":
      _0x431dfb = _0x595a77(_0x1b2b98, 0);
      break;
    case "amount_with_comma_separator":
      _0x431dfb = _0x595a77(_0x1b2b98, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x431dfb = _0x595a77(_0x1b2b98, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      _0x431dfb = _0x595a77(_0x1b2b98, 2, " ", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      _0x431dfb = _0x595a77(_0x1b2b98, 0, " ", ",");
      break;
    case "amount_with_apostrophe_separator":
      _0x431dfb = _0x595a77(_0x1b2b98, 2, "'", ".");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      _0x431dfb = _0x595a77(_0x1b2b98, 0, "'", ".");
      break;
  }
  return _0x2d60f2.replace(_0x41b2f3, _0x431dfb);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super(), this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.dataset.handle || !this.dataset.id || !this.dataset.mainProduct || !this.dataset.requirement || !this.dataset.type) return;
    updateGiftGoalInStorage({
      "giftHandle": this.dataset.handle,
      "giftVariantId": this.dataset.id,
      "unlockType": this.dataset.type,
      "unlockRequirement": Number(this.dataset.requirement),
      "unlockTarget": this.dataset.mainProduct
    });
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const _0x140ca0 = document.querySelector("cart-drawer");
  _0x140ca0 && _0x140ca0.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x47ed4c => {
    if (_0x47ed4c.addRemoveFromCart) _0x47ed4c.addRemoveFromCart();
  });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(), this.offerItems = this.querySelectorAll(".main-offer-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePrices && (this.priceSpan = this.querySelector(".bundle-deals__total-price-js"), this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat);
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var _0x5a18ae = 0,
      _0x2413b8 = 0;
    for (let _0xb67cd4 = 0; _0xb67cd4 < this.offerItems.length; _0xb67cd4++) {
      _0x5a18ae += parseInt(this.offerItems[_0xb67cd4].price), _0x2413b8 += parseInt(this.offerItems[_0xb67cd4].comparePrice);
    }
    _0x5a18ae = _0x5a18ae * this.percentageLeft - this.fixedDiscount, displayPrices(_0x5a18ae, _0x2413b8, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name, this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea"), this.inputRadios = this.querySelectorAll("[type=\"radio\"]"), this.select = this.querySelector(".select__select"), this.productForm = document.getElementById("product-form-" + this.dataset.section), this.prevValue = this.dataset.defaultValue, this.isRequired = this.dataset.required === "true", this.isText = true, this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") this.isText = false;
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true, this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc"), this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section), this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label"), this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error"), this.atcErrorMsg = this.dataset.atcErrorMsg, this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      if (this.mainAtcBtnError) this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true", this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label"), this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        if (this.stickyAtcBtnError) this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) this.input.addEventListener("input", this.handleChange.bind(this));
    this.inputRadios.forEach(_0x300a85 => {
      _0x300a85.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(_0x2b9167) {
    const _0x40a976 = _0x2b9167.target.value.trim();
    if (_0x2b9167.target.checkValidity()) this.prevValue = _0x40a976;else {
      _0x2b9167.target.value = this.prevValue;
      return;
    }
    this.dataset.value = _0x40a976, this.productFormInput.value = _0x40a976;
    if (this.isRequired && this.isText) this.validateValue(_0x40a976, _0x2b9167.target);
  }
  validateValue(_0x137209, _0x54b110) {
    const _0x2b14f6 = _0x137209.length > 0 ? true : false;
    if (_0x2b14f6 === this.isValid) return;
    this.isValid = _0x2b14f6;
    _0x54b110 && (this.isValid ? (_0x54b110.classList.remove("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1) : (_0x54b110.classList.add("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
    const _0x2bf458 = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      _0x2be758 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(_0x1b8fed => {
      _0x2bf458 && !_0x2be758 ? _0x1b8fed.removeAttribute("disabled") : _0x1b8fed.setAttribute("disabled", "");
    });
    if (this.atcErrorMsg.length === 0) return;
    _0x2bf458 ? (this.mainAtcBtnLabel.style.display = "", this.mainAtcBtnError.style.display = "none", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "", this.stickyAtcBtnError.style.display = "none")) : (this.mainAtcBtnLabel.style.display = "none", this.mainAtcBtnError.style.display = "", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "none", this.stickyAtcBtnError.style.display = ""));
  }
  createInputs() {
    this.productFormInput = document.createElement("input"), this.productFormInput.setAttribute("type", "hidden"), this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]"), this.productFormInput.value = this.dataset.defaultValue, this.productFormInput.classList.add("shrine-property-input"), this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.secondarySelectSelector = "StickyAtcVariantPicker-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = false, this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true", this.prependMedia = this.dataset.disablePrepend != "true", this.filtering = this.dataset.hasFiltering === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.hasQuantityBreaksPicker && (this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle, this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(true, "", false), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
    }
  }
  updateOptions() {
    const _0xe93166 = [];
    this.querySelectorAll(".product-form__input").forEach(_0x407dcd => {
      let _0x51bb11;
      const _0x49fce6 = _0x407dcd.querySelector(".product-form__input__type").dataset.type;
      _0x49fce6 == "dropdown" || _0x49fce6 == "dropdwon" ? _0x51bb11 = _0x407dcd.querySelector(".select__select").value : _0x51bb11 = _0x407dcd.querySelector("input[type=\"radio\"]:checked").value, _0xe93166.push(_0x51bb11);
    }), this.options = _0xe93166;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(_0x28377f => {
      return !_0x28377f.options.map((_0x2de9ac, _0x280a98) => {
        return this.options[_0x280a98] === _0x2de9ac;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const _0x12ba54 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x12ba54.forEach(_0x54ff1f => _0x54ff1f.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const _0x437b07 = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!_0x437b07) return;
    const _0x44ab60 = _0x437b07.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    _0x437b07.prepend(_0x44ab60);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const _0x44e92c = document.getElementById("Share-" + this.dataset.section);
    if (!_0x44e92c || !_0x44e92c.updateUrl) return;
    _0x44e92c.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const _0x3e5702 = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    _0x3e5702.forEach(_0x6f4f91 => {
      const _0x46e7be = _0x6f4f91.querySelector("input[name=\"id\"]");
      _0x46e7be.value = this.currentVariant.id, _0x46e7be.dispatchEvent(new Event("change", {
        "bubbles": true
      }));
    });
  }
  updateVariantStatuses() {
    const _0x162658 = this.variantData.filter(_0x34bae3 => this.querySelector(":checked").value === _0x34bae3.option1);
    let _0x233812;
    this.isSecondary && this.secondarySelect ? _0x233812 = [...this.secondarySelect.querySelectorAll(".product-form__input")] : _0x233812 = [...this.querySelectorAll(".product-form__input")], _0x233812.forEach((_0x19b5e0, _0x4b3735) => {
      if (_0x4b3735 === 0) return;
      const _0x1e0deb = [..._0x19b5e0.querySelectorAll("input[type=\"radio\"], .select__select option")],
        _0x5e5f93 = _0x233812[_0x4b3735 - 1].querySelector(":checked").value,
        _0x5e1cbd = _0x162658.filter(_0x480e15 => _0x480e15.available && _0x480e15["option" + _0x4b3735] === _0x5e5f93).map(_0x2ad087 => _0x2ad087["option" + (_0x4b3735 + 1)]),
        _0x561cbc = _0x162658.filter(_0xd88905 => _0xd88905["option" + _0x4b3735] === _0x5e5f93).map(_0xfc946d => _0xfc946d["option" + (_0x4b3735 + 1)]);
      this.setInputAvailability(_0x1e0deb, _0x5e1cbd, _0x561cbc, this.skipNonExistent, this.skipUnavailable);
    });
  }
  setInputAvailability(_0x5aef05, _0x21cf41, _0x568d89, _0x2a78a5 = false, _0x1ff8f4 = false) {
    _0x5aef05.forEach(_0x1b08b8 => {
      _0x1b08b8.classList.remove("unavailable", "non-existent", "disabled"), _0x1b08b8.removeAttribute("disabled"), _0x1b08b8.removeAttribute("hidden");
      const _0x3ab883 = _0x1b08b8.getAttribute("value");
      let _0x323f98 = null;
      _0x1b08b8.dataset.swatch === "true" && (_0x323f98 = _0x1b08b8.closest(".color-swatch"));
      if (_0x323f98) _0x323f98.classList.remove("unavailable", "non-existent", "disabled");
      if (_0x568d89.includes(_0x3ab883)) {
        if (_0x21cf41.includes(_0x3ab883)) {
          if (_0x1b08b8.nodeName === "OPTION") _0x1b08b8.innerText = _0x3ab883;else {
            _0x1b08b8.classList.remove("disabled");
            if (_0x323f98) _0x323f98.classList.remove("disabled");
          }
        } else {
          if (_0x1b08b8.nodeName === "OPTION") _0x1b08b8.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x3ab883), _0x1b08b8.classList.add("unavailable"), _0x1ff8f4 && (_0x1b08b8.setAttribute("disabled", ""), _0x1b08b8.setAttribute("hidden", ""));else {
            _0x1b08b8.classList.add("disabled", "unavailable");
            if (_0x323f98) _0x323f98.classList.add("disabled", "unavailable");
          }
        }
      } else {
        if (_0x1b08b8.nodeName === "OPTION") _0x1b08b8.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x3ab883), _0x1b08b8.classList.add("non-existent"), _0x2a78a5 && (_0x1b08b8.setAttribute("disabled", ""), _0x1b08b8.setAttribute("hidden", ""));else {
          _0x1b08b8.classList.add("disabled", "non-existent");
          if (_0x323f98) _0x323f98.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const _0x27bd6e = document.querySelector("pickup-availability");
    if (!_0x27bd6e) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (_0x27bd6e.fetchAvailability) _0x27bd6e.fetchAvailability(this.currentVariant.id);
    } else _0x27bd6e.removeAttribute("available"), _0x27bd6e.innerHTML = "";
  }
  removeErrorMessage() {
    const _0x3978d2 = this.closest("section");
    if (!_0x3978d2) return;
    const _0x3bfc33 = _0x3978d2.querySelector("product-form");
    if (_0x3bfc33) _0x3bfc33.handleErrorMessage();
  }
  renderProductInfo() {
    const _0x1c935c = this.currentVariant.id,
      _0x471529 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + _0x1c935c + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(_0x6ef2f => _0x6ef2f.text()).then(_0x39a433 => {
      if (this.currentVariant.id !== _0x1c935c) return;
      const _0x12ad38 = new DOMParser().parseFromString(_0x39a433, "text/html"),
        _0xed0343 = document.getElementById("price-" + this.dataset.section),
        _0x39a1f6 = _0x12ad38.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _0x70b986 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
        _0xe263e7 = _0x12ad38.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _0x329053 = document.getElementById("sticky-atc-price-" + this.dataset.section),
        _0x577e1a = _0x12ad38.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _0x28a729 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      if (_0x28a729 && this.currentVariant.featured_image) _0x28a729.src = this.currentVariant.featured_image.src;
      const _0x3ddb43 = document.getElementById("main-atc-price-" + this.dataset.section),
        _0x52d190 = _0x12ad38.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _0x2383f1 = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]"),
        _0x42217f = _0x12ad38.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]"),
        _0x519b23 = _0x12ad38.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _0x3e98a1 = document.getElementById("Sku-" + this.dataset.section),
        _0x4f4b71 = _0x12ad38.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _0x1e1281 = document.getElementById("Inventory-" + this.dataset.section);
      if (_0xed0343 && _0x39a1f6) _0xed0343.innerHTML = _0x39a1f6.innerHTML;
      if (_0x70b986 && _0xe263e7) _0x70b986.innerHTML = _0xe263e7.innerHTML;
      if (_0x329053 && _0x577e1a) _0x329053.innerHTML = _0x577e1a.innerHTML;
      if (_0x52d190 && _0x3ddb43) _0x3ddb43.innerHTML = _0x52d190.innerHTML;
      if (_0x2383f1 && _0x42217f) for (var _0x4f0afa = 0; _0x4f0afa < _0x2383f1.length; _0x4f0afa++) {
        _0x2383f1[_0x4f0afa].innerHTML = _0x42217f[_0x4f0afa].innerHTML;
      }
      if (_0x4f4b71 && _0x1e1281) _0x1e1281.innerHTML = _0x4f4b71.innerHTML;
      _0x519b23 && _0x3e98a1 && (_0x3e98a1.innerHTML = _0x519b23.innerHTML, _0x3e98a1.classList.toggle("visibility-hidden", _0x519b23.classList.contains("visibility-hidden")));
      if (this.QuantityBreaks) {
        const _0x294c75 = _0x12ad38.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          _0x36cc12 = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
          _0x990475 = _0x294c75.querySelectorAll(".dynamic-price");
        for (let _0x414d7c = 0; _0x414d7c < _0x36cc12.length; _0x414d7c++) {
          _0x36cc12[_0x414d7c].innerHTML = _0x990475[_0x414d7c].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(_0x10a797 => {
            _0x10a797.dataset.selectedId = this.currentVariant.id;
          });
          const _0x55fd53 = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
            _0x414414 = _0x294c75.querySelectorAll(".quantity-break__variant-select");
          for (let _0x31d5e7 = 0; _0x31d5e7 < _0x55fd53.length; _0x31d5e7++) {
            _0x55fd53[_0x31d5e7].innerHTML = _0x414414[_0x31d5e7].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        this.currentVariant.featured_image && this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach(_0x190c27 => {
          _0x190c27.src = this.currentVariant.featured_image.src;
        }), this.QuantityBreaks.updatePdpPrices && (this.QuantityBreaks.dataset.basePrice = _0x294c75.dataset.basePrice, this.QuantityBreaks.labels.forEach(_0x4d3707 => {
          _0x4d3707.dataset.baseComparePrice = _0x294c75.querySelector("label[data-input=\"" + _0x4d3707.dataset.input + "\"]").dataset.baseComparePrice;
        }), this.QuantityBreaks.initOfferPrices(true), this.QuantityBreaks.updateInnerPrices());
      }
      const _0x7d3bea = document.getElementById("SubscriptionWidget-" + this.dataset.section),
        _0x3c3df7 = _0x12ad38.getElementById("SubscriptionWidget-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      if (_0x7d3bea) {
        if (!_0x3c3df7) _0x7d3bea.classList.add("hidden");else {
          _0x7d3bea.dataset.basePrice = _0x3c3df7.dataset.basePrice || "", _0x7d3bea.dataset.baseComparePrice = _0x3c3df7.dataset.baseComparePrice || "";
          const _0xb9832b = (_0x7d3bea.dataset.firstSellingPlanId || "") !== (_0x3c3df7.dataset.firstSellingPlanId || "");
          if (_0xb9832b && typeof _0x7d3bea.hydrateFromExternalHTML === "function") _0x7d3bea.hydrateFromExternalHTML(_0x3c3df7);else {
            const _0x19c8fe = _0x7d3bea.querySelectorAll(".one-time-price-update"),
              _0x48c108 = _0x3c3df7.querySelectorAll(".one-time-price-update");
            for (let _0x35825f = 0; _0x35825f < _0x19c8fe.length; _0x35825f++) {
              _0x19c8fe[_0x35825f].innerHTML = _0x48c108[_0x35825f].innerHTML;
            }
            if (_0x7d3bea.updatePrices) _0x7d3bea.updateAllPrices();
          }
        }
      }
      if (this.hasQuantityBreaksPicker) {
        const _0x59e9ca = _0x12ad38.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          _0x4e068d = this.querySelectorAll(".dynamic-price"),
          _0x29c5c1 = _0x59e9ca.querySelectorAll(".dynamic-price");
        for (let _0x3fde22 = 0; _0x3fde22 < _0x4e068d.length; _0x3fde22++) {
          _0x4e068d[_0x3fde22].innerHTML = _0x29c5c1[_0x3fde22].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const _0x190a4d = this.querySelectorAll(".quantity-break__image img"),
            _0x497b64 = _0x59e9ca.querySelectorAll(".quantity-break__image img");
          for (let _0x551aa5 = 0; _0x551aa5 < _0x190a4d.length; _0x551aa5++) {
            _0x190a4d[_0x551aa5].src = _0x497b64[_0x551aa5].src;
          }
        }
        const _0x4c1165 = _0x59e9ca.querySelectorAll(".quantity-break[data-base-price]"),
          _0x1902d9 = this.querySelectorAll(".quantity-break");
        for (let _0x40386a = 0; _0x40386a < _0x1902d9.length && _0x40386a < _0x4c1165.length; _0x40386a++) {
          _0x4c1165[_0x40386a].dataset.basePrice && (_0x1902d9[_0x40386a].dataset.basePrice = _0x4c1165[_0x40386a].dataset.basePrice, _0x1902d9[_0x40386a].dataset.baseComparePrice = _0x4c1165[_0x40386a].dataset.baseComparePrice);
        }
        const _0x5a4f16 = document.getElementById("SubscriptionWidget-" + this.dataset.section);
        _0x5a4f16 && _0x5a4f16.isSubSelected && this.updateQuantityBreaksPickerPrices && this.updateQuantityBreaksPickerPrices(_0x5a4f16.discountType, _0x5a4f16.discountValue, _0x5a4f16.moneyFormat);
      }
      if (this.secondarySelect) {
        const _0x4408af = _0x12ad38.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (_0x4408af) this.secondarySelect.innerHTML = _0x4408af.innerHTML;
      }
      const _0x149d17 = document.getElementById("price-" + this.dataset.section);
      if (_0x149d17) _0x149d17.classList.remove("visibility-hidden");
      this.dataset.options = this.currentVariant.options.join(",");
      if (_0x1e1281) _0x1e1281.classList.toggle("visibility-hidden", _0x4f4b71.innerText === "");
      const _0x106394 = _0x12ad38.getElementById("ProductSubmitButton-" + _0x471529);
      this.toggleAddButton(_0x106394 ? _0x106394.hasAttribute("disabled") : true, window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
        "data": {
          "sectionId": _0x471529,
          "html": _0x12ad38,
          "variant": this.currentVariant
        }
      });
    });
  }
  toggleAddButton(_0x2b0b61 = true, _0x53491a, _0x1d0fe8 = true) {
    const _0x72b257 = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x72b257) return;
    const _0x1453ae = _0x72b257.querySelector("[name=\"add\"]");
    if (!_0x1453ae) return;
    const _0x4ae0e0 = document.querySelectorAll(".main-product-atc");
    var _0x1d2631 = _0x72b257.querySelector(".main-atc__label__text");
    if (!_0x1d2631) _0x1d2631 = _0x72b257.querySelector(".main-atc__label");
    const _0x565137 = _0x72b257.querySelector(".main-atc-price"),
      _0x2a35e = document.querySelector(".sticky-atc__add_button");
    let _0x8dc46e = null,
      _0x1db950 = null;
    _0x2a35e && (_0x8dc46e = _0x2a35e.querySelector(".sticky-atc__label__text"), _0x1db950 = _0x2a35e.querySelector(".sticky-atc__button-price"));
    if (_0x2b0b61) {
      _0x1453ae.setAttribute("disabled", "disabled"), _0x1453ae.setAttribute("data-unavailable", "true");
      if (_0x53491a && _0x1d2631) _0x1d2631.textContent = _0x53491a;
      if (_0x53491a && _0x8dc46e && _0x2a35e.dataset.label) _0x8dc46e.textContent = _0x53491a;
      _0x4ae0e0.forEach(_0x7394bf => {
        _0x7394bf.setAttribute("disabled", "disabled");
      });
      if (_0x565137) _0x565137.classList.add("hidden");
      if (_0x1db950) _0x1db950.classList.add("hidden");
    } else {
      _0x1453ae.setAttribute("data-unavailable", "false");
      const _0x476b8d = _0x1453ae.dataset.customLabel ?? window.variantStrings.addToCart;
      if (_0x1d2631) _0x1d2631.textContent = _0x476b8d;
      if (_0x565137) _0x565137.classList.remove("hidden");
      if (_0x8dc46e && _0x2a35e.dataset.label) _0x8dc46e.textContent = _0x2a35e.dataset.label;
      if (_0x1db950) _0x1db950.classList.remove("hidden");
      _0x1453ae.dataset.requiredFields === _0x1453ae.dataset.validFields && (_0x1453ae.removeAttribute("disabled"), _0x4ae0e0.forEach(_0x30d3b4 => {
        _0x30d3b4.removeAttribute("disabled");
      }));
    }
    if (!_0x1d0fe8) return;
  }
  setUnavailable() {
    const _0x2ea331 = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x2ea331) return;
    const _0x363919 = _0x2ea331.querySelector("[name=\"add\"]");
    var _0x3a74cc = _0x2ea331.querySelector(".main-atc__label__text");
    if (!_0x3a74cc) _0x3a74cc = _0x2ea331.querySelector(".main-atc__label");
    const _0xdca01d = document.getElementById("price-" + this.dataset.section),
      _0x4e3d27 = document.getElementById("Inventory-" + this.dataset.section),
      _0xb089fa = document.getElementById("Sku-" + this.dataset.section);
    if (!_0x363919) return;
    if (_0x3a74cc) _0x3a74cc.textContent = window.variantStrings.unavailable;
    if (_0xdca01d) _0xdca01d.classList.add("visibility-hidden");
    if (_0x4e3d27) _0x4e3d27.classList.add("visibility-hidden");
    if (_0xb089fa) _0xb089fa.classList.add("visibility-hidden");
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent), this.variantData;
  }
  updateQuantityBreaksPickerPrices(_0x29aeb9, _0xe61766, _0x5b8f18) {
    if (!this.hasQuantityBreaksPicker) return;
    const _0x6d3a38 = this.querySelectorAll(".quantity-break");
    if (!_0x6d3a38.length) return;
    _0x6d3a38.forEach(_0x56bd31 => {
      if (!_0x56bd31.dataset.basePrice) return;
      const _0x29b595 = parseInt(_0x56bd31.dataset.basePrice),
        _0x1bf964 = parseInt(_0x56bd31.dataset.baseComparePrice) || _0x29b595;
      let _0x17f6c5 = _0x29b595;
      if (_0x29aeb9 && _0xe61766) {
        if (_0x29aeb9 === "fixed_amount") _0x17f6c5 = Math.max(0, _0x29b595 - _0xe61766);else {
          if (_0x29aeb9 === "percentage") _0x17f6c5 = Math.round(_0x29b595 * (100 - _0xe61766) / 100);else _0x29aeb9 === "price" && (_0x17f6c5 = _0xe61766);
        }
      }
      const _0x1e6a9e = _0x1bf964 - _0x17f6c5,
        _0xe5ef4 = Math.round(_0x1e6a9e / 100) * 100,
        _0x31b407 = _0x1bf964 > 0 ? Math.round(_0x1e6a9e / _0x1bf964 * 100) : 0,
        _0x38ef5d = formatMoney(_0x17f6c5, _0x5b8f18, true),
        _0x951875 = formatMoney(_0x1bf964, _0x5b8f18, true),
        _0x3113fe = formatMoney(_0x1e6a9e, _0x5b8f18, true),
        _0x18885e = formatMoney(_0xe5ef4, _0x5b8f18, true),
        _0x3cc0a4 = _0x56bd31.querySelectorAll(".variant-price-update[data-text]");
      _0x3cc0a4.forEach(_0xc837cf => {
        let _0x1c0519 = _0xc837cf.dataset.text;
        _0x1c0519 = _0x1c0519.replace("[price]", _0x38ef5d), _0x1c0519 = _0x1c0519.replace("[compare_price]", _0x951875), _0x1c0519 = _0x1c0519.replace("[amount_saved]", _0x3113fe), _0x1c0519 = _0x1c0519.replace("[amount_saved_rounded]", _0x18885e), _0x1c0519 = _0x1c0519.replace("[percentage_saved]", _0x31b407 + "%"), _0xc837cf.innerHTML = _0x1c0519;
      });
      const _0x2d8866 = _0x56bd31.querySelector(".quantity-break__compare-price");
      _0x2d8866 && (_0x1bf964 > _0x17f6c5 ? _0x2d8866.classList.remove("hidden") : _0x2d8866.classList.add("hidden"));
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = "variant-selects-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = "variant-selects-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(), this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(true, "", false), this.updateVariantStatuses(), !this.currentVariant ? (this.toggleAddButton(true, "", true), this.setUnavailable()) : (this.updateMedia(), this.updateVariantInput(), this.updateQuickAddUrl(), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const _0x84d284 = document.getElementById(this.dataset.section + "-image");
    if (!_0x84d284) return;
    const _0x8478b1 = this.currentVariant.featured_media.preview_image,
      _0x7f25d3 = _0x8478b1.src.split("?")[0],
      _0x413cf6 = [165, 360, 533, 720, 940, 1066],
      _0x3ca486 = _0x413cf6.filter(_0x112a6e => _0x8478b1.width >= _0x112a6e).map(_0x357511 => _0x7f25d3 + "?width=" + _0x357511 + " " + _0x357511 + "w").join(", ");
    _0x84d284.srcset = _0x3ca486 + ", " + _0x7f25d3 + " " + _0x8478b1.width + "w", _0x84d284.src = _0x7f25d3 + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
